import Vue from "vue";
import Vuex, { mapActions } from "vuex";
var firebase = require("firebase/app");
import router from "../router";
import db from "../main";
import Alert from "../components/Alert";
import { user } from "firebase-functions/lib/providers/auth";
import axios from "axios";
var moment = require("moment");
moment.locale("pt");
import { Notification } from "./notification";
Vue.use(Vuex);

var bootbox = require("bootbox");

export default new Vuex.Store({
  state: {
    participantsArray: [],
    user: "",
    users: [],
    error: "",
    errorMessage: {
      color: "",
      text: "",
    },
    dismissSecs: 4,
    dismissCountDown: 0,
    searchData: "",
    globalSearchData: "",
    preloader: false,
    proposals: [],
    proposal: {
      cpf: "",
      fullName: "",
      pis: "",
      occupation: "",
      phoneNumber: "",
      maritalStatusField: "",
      email: "",
      salaryAmount: null,
      fgtsCheck: false,
      propertyCategory: null,
      propertyType: null,
      propertyValue: 0,
      intendedFinancingValue: 0,
      period: "",
      operationModality: null,
      amortizationSystem: null,
      indexer: null,
      propertyLocation: {},
      comments: "",
      acquisitionForecast: [],
      matricula: 0,
      issueDate: "",
      operationNumber: 0,
      notaryExpensesAmount: 0,
      fgtsValue: 0,
      steps: {
        note: "",
        riskAssessment: {
          actived: false,
          badgeColor: "",
          dueDate: "",
          note: "",
          situation: "",
          status: "",
        },
        engineering: {
          actived: false,
          badgeColor: "",
          dueDate: "",
          note: "",
          situation: "",
          status: "",
        },
        forms: {
          actived: false,
          badgeColor: "",
          dueDate: "",
          note: "",
          situation: "",
          status: "",
        },
        fgts: {
          actived: false,
          badgeColor: "",
          dueDate: "",
          note: "",
          situation: "",
          status: "",
        },
        dossier: {
          actived: false,
          badgeColor: "",
          dueDate: "",
          note: "",
          situation: "",
          status: "",
        },
        contract: {
          actived: false,
          badgeColor: "",
          dueDate: "",
          note: "",
          situation: "",
          status: "",
        },
      },
    },
    proposalToEdit: null,
    proposalToCheck: null,
    bankBranches: {},
    bankBranch: "",
    fgtsDemands: [],
    optionsPropertyCategory: [
      { value: null, text: "Selecione a categoria do imóvel" },
      { value: "Novo", text: "Aquisição de Imóvel novo" },
      { value: "Usado", text: "Aquisição de Imóvel Usado" },
      { value: "CAIXA", text: "Imóveis CAIXA" },
      { value: "Terreno", text: "Aquisição de Terreno" },
      { value: "Construção em terreno ", text: "Aquisição de Construção" },
      { value: "Terreno e Construção", text: "Aquisição de Terreno e Construção" },
    ],
    optionsPropertyType: [
      { value: null, text: "Selecione o tipo de imóvel" },
      { value: "Residencial", text: "Residencial" },
      { value: "Comecial", text: "Comercial" },
    ],
    optionsAmortizationSystem: [
      { value: null, text: "Amortização" },
      { value: "SAC", text: "SAC" },
      { value: "PRICE", text: "PRICE" },
    ],
    optionsIndexer: [
      { value: null, text: "Indexador" },
      { value: "TR", text: "TR" },
      { value: "IPCA", text: "IPCA" },
      { value: "TAXA FIXA", text: "TAXA FIXA" },
    ],
    optionsFinancialSystem: [
      { value: null, text: "Sistema Financeiro" },
      { value: "SFH", text: "SFH" },
      { value: "SFI", text: "SFI" },
    ],
    optionsOperationModality: [
      { value: null, text: "Selecione a Modalidade de Financiamento" },
      { value: "SBPE", text: "SBPE" },
      { value: "CCFGTS", text: "CCFGTS" },
      { value: "PMCMV", text: "PMCMV" },
      { value: "PRÓ COTISTA", text: "PRÓ COTISTA" },
      { value: "CRF", text: "CRF" },
    ],
    file: [],
    documentFiles: {},
    getCommonBuyerTaskList: [],
    getCommonSellerTaskList: [],
    getCommonPropertyTaskList: [],
    getBuyerTaskList: [],
    getSellerTaskList: [],
    getPropertyTaskList: [],
    selectedPendingOption: "Risk Assessment",
    condfigOrderBy_proposal: "progressValue",
    configsOrder_proposal: "desc",
    allProposals: [],
    post: {
      author: "",
      body: "",
      //categories: [],
      created: "",
      image_alt: "",
      updated: "",
      meta_description: "",
      published: "",
      seo_title: "",
      slug: "",
      status: "",
      subTitle: "",
      summary: "",
      tags: [],
      title: "",
      image_url: "",
      post_date: "",
    },
    posts: [],
    loadingBtn: false,
    newProposalsLength: 0,
    newChartProposalsLength: 0,
    inServiceProposalsLength: 0,
    commonBuyerTask: [],
    commonSellerTask: [],
    commonPropertyTask: [],
    proposalBuyerTask: [],
    proposalSellerTask: [],
    proposalPropertyTask: [],
    filteredProposals: [],
    approvedArr: [],
    contractedArr: [],
    failedArr: [],
    pendingArr: [],
    progressArr: [],
    inactiveArr: [],
    atendimentoProposals: [],
    statePeriodAmount: null,
    currentYearProposals: [],

    notifications: [],
    notificationsToAdd: [],
  },
  components: {
    Alert,
  },
  mutations: {
    /* ==================================================================
    Global Data Mutations
    ================================================================== */

    setDataPreloader(state, payload) {
      state.preloader = payload;
    },
    setBankBranches(state, bankBranches) {
      state.bankBranches = bankBranches;
    },

    /* ==================================================================
    User Authentication Mutations
    ================================================================== */
    setUser(state, payload) {
      state.user = payload;
    },
    setUsers(state, payload) {
      state.users = payload;
    },
    setError(state, payload) {
      state.error = payload;
      state.dismissCountDown = state.dismissSecs;
    },
    setErrorMessage(state, payload) {
      state.errorMessage = payload;
      state.dismissCountDown = state.dismissSecs;
    },
    setDismissCountDown(state, payload) {
      state.dismissCountDown = payload;
    },

    mutateNotification(state, payload) {
      state.notifications = payload;
    },
    addNotificationData(state, payload) {
      let notificationExist = state.notifications.some(
        (not) => not.notId === payload.notId
      );
      if (!notificationExist) state.notifications.push(payload);
    },
    setModificationNotification(state, payload) {
      state.notificationsToAdd.push(payload);
    },
    removeModificationNotification(state, payload) {
      state.notificationsToAdd = payload;
    },
    removeNotificationState(state, payload) {
      const index = state.notifications.findIndex((notifi) => {
        return notifi.notId === payload;
      });
      if (index > -1) state.notifications.splice(index, 1);
    },

    /* ==================================================================
    Proposals Mutations
    ================================================================== */
    setProposal(state, payload) {
      state.proposal = payload;
    },
    setProposals(state, proposals) {
      state.proposals = proposals;
    },
    setAtendimentoProposals(state, proposals) {
      state.atendimentoProposals = proposals;
    },
    updateProposal(state, payload) {
      const index = state.proposals.findIndex((item) => item.id === payload.id);
    },
    delProposal(state, id) {
      state.proposals = state.proposals.filter((doc) => {
        return doc.id != id;
      });
    },
    setFgtsDemands(state, fgtsDemands) {
      state.fgtsDemands = fgtsDemands;
    },

    setBlankProposal(state) {
      state.proposal = {
        cpf: "",
        fullName: "",
        pis: "",
        occupation: "",
        phoneNumber: "",
        maritalStatusField: "",
        email: "",
        salaryAmount: null,
        fgtsCheck: false,
        propertyCategory: null,
        propertyType: null,
        propertyValue: 0,
        intendedFinancingValue: 0,
        period: "",
        operationModality: null,
        amortizationSystem: null,
        indexer: null,
        propertyLocation: {},
        comments: "",
        acquisitionForecast: [],
        matricula: 0,
        issueDate: "",
        operationNumber: 0,
        notaryExpensesAmount: 0,
        fgtsValue: 0,
        steps: {
          note: "",
          riskAssessment: {
            actived: false,
            badgeColor: "",
            dueDate: "",
            note: "",
            situation: "",
            status: "",
          },
          engineering: {
            actived: false,
            badgeColor: "",
            dueDate: "",
            note: "",
            situation: "",
            status: "",
          },
          forms: {
            actived: false,
            badgeColor: "",
            dueDate: "",
            note: "",
            situation: "",
            status: "",
          },
          fgts: {
            actived: false,
            badgeColor: "",
            dueDate: "",
            note: "",
            situation: "",
            status: "",
          },
          dossier: {
            actived: false,
            badgeColor: "",
            dueDate: "",
            note: "",
            situation: "",
            status: "",
          },
          contract: {
            actived: false,
            badgeColor: "",
            dueDate: "",
            note: "",
            situation: "",
            status: "",
          },
        },
      };
    },

    setProposalToEdit(state, payload) {
      state.proposalToEdit = payload;
    },

    setProposalToCheck(state, payload) {
      state.proposalToCheck = payload;
    },

    setUserProposals(state, payload) {
      state.proposal.cpf = payload[0].cpf;
      state.proposal.fullName = payload[0].fullName;
      state.proposal.pis = payload[0].pis;
      state.proposal.occupation = payload[0].occupation;
      state.proposal.phoneNumber = payload[0].phoneNumber;
      state.proposal.maritalStatusField = payload[0].maritalStatusField;
      state.proposal.email = payload[0].email;
      state.proposal.salaryAmount = payload[0].salaryAmount;
      payload.forEach((form) => {
        if (form.fgtsCheck === true) state.proposal.fgtsCheck = true;
      });
      if (payload.length > 1) {
        state.proposal.participants = payload.slice(1, payload.length);
      }
    },
    setParticipantArray(state, payload) {
      state.participantsArray = payload;
    },

    setFile(state, payload) {
      state.file.push({
        file: payload,
        name: payload.name,
        type: payload.type,
      });
    },
    removeFile(state, payload) {
      state.file.splice(payload, 1);
    },
    setBlankFileArray(state, payload) {
      state.file = payload;
    },

    getDocuments(state, payload) {
      state.documentFiles = payload;
    },

    updatePendingOption(state, payload) {
      state.selectedPendingOption = payload;
    },

    setcondfigOrderBy_proposal(state, payload) {
      state.condfigOrderBy_proposal = payload;
    },

    setconfigsOrder_proposal(state, payload) {
      state.configsOrder_proposal = payload;
    },

    setAllProposals(state, payload) {
      state.allProposals = payload;
    },
    setFilteredProposals(state, payload) {
      state.filteredProposals = payload;
    },

    /* ==================================================================
    Blog Mutations
    ================================================================== */
    setPost(state, payload) {
      state.post = payload;
    },
    setPosts(state, payload) {
      state.posts = payload;
    },
    setPostToEdit(state, payload) {
      state.post = payload;
    },
    delPost(state, id) {
      state.posts = state.posts.filter((doc) => {
        return doc.id != id;
      });
    },

    /* ==================================================================
    Another Mutations
    ================================================================== */
    setLoadingBtn(state, payload) {
      state.loadingBtn = payload;
    },
    clearProposalBuyer(state) {
      state.proposalBuyerTask = [];
    },
    clearProposalSeller(state) {
      state.proposalSellerTask = [];
    },
    clearProposalProperty(state) {
      state.proposalPropertyTask = [];
    },
    setPeriodAmount(state, payload) {
      state.statePeriodAmount = payload;
    },
    setCurrentYearProposals(state, payload) {
      state.currentYearProposals = payload;
    },
  },
  actions: {
    /* ==================================================================
    Global data Handling Functions
    ================================================================== */
    ...mapActions(["showAlert"]),
    searchFieldAction({ commit, state }, payload) {
      //console.log(payload);
      state.searchData = payload.toLowerCase();
    },
    globalSearchFieldAction({ commit, state }, payload) {
      state.globalSearchData = payload;
    },
    getBankBranches({ commit }) {
      commit("setDataPreloader", true);

      //const user = firebase.auth().currentUser
      const bankBranches = [];

      db.collection("bankBranches")
        .orderBy("name")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //console.log(doc.id);
            //console.log(doc.data());
            let bankBranch = doc.data();
            bankBranch.id = doc.id;
            bankBranches.push(bankBranch);
          });
          commit("setDataPreloader", false);
        });
      commit("setBankBranches", bankBranches);
    },

    /* ==================================================================
    User Authentication Function
    ================================================================== */
    createUser({ commit }, payload) {
      commit("setLoadingBtn", true);

      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.pass)
        .then(() => {
          var user = firebase.auth().currentUser;
          user
            .updateProfile({
              displayName: payload.fullName,
            })
            .then(() => {
              user.sendEmailVerification();
              // Email sent.
              db.collection("profileUsers")
                .doc(user.uid)
                .set({
                  uid: user.uid,
                  name: user.displayName,
                  firstName: payload.firstName,
                  lastName: payload.lastName,
                  email: user.email,
                  photoUrl: user.photoURL,
                  emailVerified: false,
                  phone: payload.phoneNumber,
                  profileType: payload.profileType,
                  bankBranch: "",
                  active: false,
                  phoneVerified: false,
                  level: "Usuário",
                  linked: "",
                  created: new Date(),
                  actingRegion: payload.actingRegion,
                  averageCredit: payload.averageCredit,
                  wayOfPerformance: payload.wayOfPerformance,
                  timeToMarket: payload.timeToMarket,
                })
                .then(() => {
                  console.log("Documento Adicionado ao DB profileUsers");
                  router.push({ name: "Sucesso" });
                })
                .catch((error) => {
                  console.log("Error ao adicionar o doc: ", error);
                  commit("setLoadingBtn", false);
                });
              commit("setErrorMessage", {
                color: "warning",
                text:
                  "Estamos quase lá! Valide seu e-mail no link enviado para o e-mail informado.",
              });
            })
            .catch((error) => {
              // An error happened.
              commit("setErrorMessage", {
                color: "danger",
                text:
                  "Não foi possível enviar o E-mail de validação de cadastrado com sucesso!",
              });
              commit("setLoadingBtn", false);
            });
        })
        .catch((error) => {
          console.log(error);
          commit("setError", error.code);
          if (error.code === "auth/invalid-email") {
            commit("setErrorMessage", {
              color: "danger",
              text: "E-mail e/ou usuário inválido(s)",
            });
          } else if (error.code === "auth/email-already-in-use") {
            commit("setErrorMessage", {
              color: "danger",
              text: "E-mail de usuário já registrado",
            });
          } else if (error.code === "auth/weak-password") {
            commit("setErrorMessage", {
              color: "warning",
              text: "Senha deve possuir mais que 6 caracteres",
            });
          } else {
            commit("setErrorMessage", {
              color: "warning",
              text: "Erro de sistema",
            });
          }
          commit("setLoadingBtn", false);
        });
    },
    loginUser({ commit }, payload) {
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.pass)
        .then((res) => {
          var userEmailVerified = res.user.emailVerified;

          var docRef = db.collection("profileUsers").doc(res.user.uid);

          docRef
            .get()
            .then(function(doc) {
              if (doc.exists) {
                const userActive = doc.data().active;

                if (!userEmailVerified) {
                  console.log("E-mail não verificado");
                  commit("setUser", null);
                  commit("setErrorMessage", {
                    color: "warning",
                    text:
                      "E-mail não verificado. Antes de prosseguir valide seu e-mail.",
                  });
                } else if (!userActive) {
                  console.log("Usuário não ativo");
                  commit("setUser", null);
                  commit("setErrorMessage", {
                    color: "warning",
                    text: "Usuário não ativo.",
                  });
                  firebase.auth().signOut();
                  bootbox.alert({
                    title: "Ativação de usuário",
                    message:
                      "Seu acesso está passando por análise de liberação por ser seu primeiro. Caso não seja seu primeiro acesso e está aparecendo essa mensagem para você envie um e-mail solicitando liberação para sac@parceirocaixa.com.br",
                    centerVertical: true,
                    locale: "pt",
                    buttons: {
                      ok: {
                        label: "Entendi!",
                      },
                    },
                  });
                } else {
                  commit("setUser", {
                    email: res.user.email,
                    uid: res.user.uid,
                    emailVerified: res.user.emailVerified,
                  }); //console.log(getUserDoc);
                  router.push({ name: "proposals" });
                }
              } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
              }
            })
            .catch(function(error) {
              console.log("Error getting document:", error);
            });
        })
        .catch((error) => {
          console.log(error);
          commit("setError", error.code);
          if (
            error.code === "auth/invalid-email" ||
            error.code === "auth/wrong-password"
          ) {
            commit("setErrorMessage", {
              color: "danger",
              text: "E-mail e/ou usuário inválido(s)",
            });
          } else if (error.code === "auth/user-not-found") {
            commit("setErrorMessage", {
              color: "danger",
              text: "Usuário não cadastrado",
            });
          } else if (error.code === "auth/user-disabled") {
            commit("setErrorMessage", {
              color: "warning",
              text: "Liberação de acesso em análise.",
            });
          } else {
            commit("setErrorMessage", {
              color: "warning",
              text: "Erro de sistema",
            });
          }
        });
    },
    recoveryPass({ commit }, payload) {
      firebase
        .auth()
        .sendPasswordResetEmail(payload.email)
        .then((res) => {
          console.log(res);
          commit("setErrorMessage", {
            color: "success",
            text: "E-mail enviado com sucesso.",
          });
        })
        .catch((error) => {
          // An error happened.
          console.log(error);
          commit("setErrorMessage", {
            color: "warning",
            text: "E-mail inválido ou não registrado.",
          });
        });
    },
    handleResetPassword({ commit }, payload) {
      firebase
        .auth()
        .confirmPasswordReset(payload.code, payload.password)
        .then(function() {
          commit("setErrorMessage", {
            color: "success",
            text: "Password changed",
          });
          router.push({ name: "login" });
        })
        .catch(function(error) {
          commit("setErrorMessage", {
            color: "danger",
            text: error,
          });
        });
    },
    handleVerifyEmail({ commit }, payload) {
      let profile;
      firebase
        .auth()
        .applyActionCode(payload.actionCode)
        .then(async (resp) => {
          await db
            .collection("profileUsers")
            .where("email", "==", payload.email)
            .get()
            .then((users) => {
              users.forEach((doc) => {
                profile = doc.data();
              });
              console.log(profile, "::::::::::::::::profile");
              db.collection("profileUsers")
                .doc(profile.uid)
                .set(
                  {
                    emailVerified: true,
                  },
                  { merge: true }
                )
                .then(() => {
                  console.log("Usuário Atualizado");
                })
                .catch((error) => {
                  console.log("Error ao adicionar o doc: ", error);
                });
            });

          const sendVerifyWelcomeEmail = firebase
            .functions()
            .httpsCallable("sendVerifyWelcomeEmail");
          sendVerifyWelcomeEmail(profile).then((result) => {
            console.log(
              result,
              "result:::::::::::::::sendVerifyWelcomeEmail",
              profile
            );
          });
        })
        .catch((error) => {
          console.log(error, "error");
        });
    },
    observer({ commit }, payload) {
      var user = firebase.auth().currentUser;

      if (payload != null) {
        //alert('Valide seu e-mail para continuar.')
        //router.push({name: 'profileInit'})

        // console.log('Estou no Get Proposals buscando as principais informações do usuário para autenticar');
        // console.log(user.email);
        // console.log(user.emailVerified);
        // console.log(user.displayName);
        // console.log(user.phoneNumber);
        // console.log(user.photoURL);

        //commit('setUser', {email:payload.email, uid: payload.uid, displayName: payload.displayName, photoURL: payload.photoURL, emailVerified: payload.emailVerified, phoneNumber: payload.phoneNumber })

        // Estado de persistência do usuário durante uma sessão aberta - Indica que o estado será mantido somente na sessão ou guia atual e será apagado quando a guia ou janela em que o usuário fez a autenticação for fechada. É aplicável apenas para apps da Web.
        // User persistence state during an open session - Indicates that the state will be maintained only in the current session or tab and will be cleared when the tab or window in which the user authenticated is closed. It is only applicable for web apps.
        firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.SESSION)
          .then(function() {
            // Existing and future Auth states are now persisted in the current
            // session only. Closing the window would clear any existing state even
            // if a user forgets to sign out.
            // ...
            // New sign-in will be persisted with session persistence.
            return firebase.auth().signInWithEmailAndPassword(email, password);
          })
          .catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
          });
        commit("setUser", payload);
      } else {
        commit("setUser", null);
        firebase.auth().signOut();
      }
    },
    logOut({ commit }) {
      firebase.auth().signOut();
      commit("setUser", null);
      router.push({ name: "login" });
    },
    getUsers({ commit }) {
      commit("setDataPreloader", true);

      const users = [];

      db.collection("profileUsers")
        .orderBy("created", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //console.log(doc.id);
            //console.log(doc.data());
            let user = doc.data();
            user.id = doc.id;
            users.push(user);
          });
          commit("setDataPreloader", false);
        });
      commit("setUsers", users);
    },
    handleAccessUser({ commit }, payload) {
      var user = payload;
      db.collection("profileUsers")
        .doc(user.uid)
        .set(
          {
            active: payload.active,
            level: payload.level,
            linked: payload.linked,
            updated: new Date(),
          },
          { merge: true }
        )
        .then(() => {
          console.log("Usuário Atualizado");
        })
        .catch((error) => {
          console.log("Error ao adicionar o doc: ", error);
        });
      console.log(user);
      commit("setError");
      if (payload.active === true) {
        commit("setErrorMessage", {
          color: "success",
          text: "Usuário desativado",
        });
      } else {
        commit("setErrorMessage", {
          color: "success",
          text: "Usuário ativado",
        });
      }
    },
    handleValidPhone({ commit }, payload) {
      var user = payload;

      db.collection("profileUsers")
        .doc(user.uid)
        .update({
          phoneVerified: !payload.phoneVerified,
          updated: new Date(),
        })
        .then(() => {
          console.log("Telefone Verificado");
        })
        .catch((error) => {
          console.log("Error ao adicionar o doc: ", error);
        });
      console.log(user);
      commit("setError");
      if (payload.phoneVerified === false) {
        commit("setErrorMessage", {
          color: "success",
          text: "Telefone verificado",
        });
      } else {
        commit("setErrorMessage", {
          color: "success",
          text: "Telefone não verificado",
        });
      }
    },
    handleValidEmail({ commit }, payload) {
      var user = payload;

      db.collection("profileUsers")
        .doc(user.uid)
        .update({
          emailVerified: !payload.emailVerified,
          updated: new Date(),
        })
        .then(() => {
          console.log("E-mail Verificado");
        })
        .catch((error) => {
          console.log("Error ao adicionar o doc: ", error);
        });
      console.log(user);
      commit("setError");
      if (payload.emailVerified === false) {
        commit("setErrorMessage", {
          color: "success",
          text: "E-mail verificado",
        });
      } else {
        commit("setErrorMessage", {
          color: "success",
          text: "E-mail não verificado",
        });
      }
    },

    /* ==================================================================
    Proposals Handling Functions
    ================================================================== */

    async getProposalForEdit({ commit }, payload) {
      let snapshot = await db
        .collection("proposals")
        .doc(payload)
        .get();
      commit("setProposalToEdit", snapshot.data());
    },

    async createProposal({ commit, dispatch, state }, payload) {
      const user = firebase.auth().currentUser;

      const stepsNote = `Corretor:
      Conta de crédito do(s) vendedor(es):
      Tipo de relacionamento:`;
      const comments = `+ Docs dos vendedores`;

      try {
        const snapshotProposal = await db
          .collection("proposals")
          .where("cpf", "==", payload.cpf)
          .where("steps.contract.situation", "==", "")
          .limit(1)
          .get();

        if (snapshotProposal.empty) {
          const doc = await db.collection("proposals").add({
            bankBranch: "",
            cpf: payload.cpf,
            name: payload.fullName,
            pis: payload.pis,
            occupation: payload.occupation,
            phoneNumber: payload.phoneNumber,
            maritalStatus: payload.maritalStatusField,
            email: payload.email,
            salaryAmount: payload.salaryAmount,
            fgts: payload.fgtsCheck,
            propertyType: payload.propertyType,
            propertyCategory: payload.propertyCategory,
            propertyValue: payload.propertyValue,
            intendedFinancingValue: payload.intendedFinancingValue,
            period: payload.period,
            amortizationSystem: payload.amortizationSystem,
            indexer: payload.indexer,
            propertyLocation: payload.propertyLocation,
            created: new Date(),
            participants: payload.participants ? payload.participants : [],
            approvedFinancingAmount: 0,
            engineeringEvaluation: 0,
            operationModality: null,
            operationValue: 0,
            fgtsResourcesValue: 0,
            comments: payload.comments ? payload.comments : comments,

            steps: {
              note: payload.steps.note ? payload.steps.note : stepsNote,
              riskAssessment: {
                actived: false,
                situation: "",
                status: "",
                dueDate: "",
                badgeColor: "light",
                note: "",
              },
              engineering: {
                actived: false,
                situation: "",
                status: "",
                dueDate: "",
                badgeColor: "light",
                note: "",
                alertRule: true,
                updatedAlert: new Date().toString(),
                alertType: "snooze",
              },
              forms: {
                actived: false,
                situation: "",
                status: "",
                dueDate: "",
                badgeColor: "light",
                note: "",
                alertRule: true,
                updatedAlert: new Date().toString(),
                alertType: "snooze",
                dueDate: "",
                badgeColor: "light",
                note: "",
                alertRule: true,
                updatedAlert: new Date().toString(),
                alertType: "snooze",
              },
              dossier: {
                actived: false,
                situation: "",
                status: "",
                dueDate: "",
                badgeColor: "light",
                note: "",
              },
              contract: {
                actived: false,
                situation: "",
                status: "",
                dueDate: "",
                badgeColor: "light",
                note: "",
                alertRule: true,
                updatedAlert: new Date().toString(),
                alertType: "snooze",
              },
              fgts: {
                actived: false,
                situation: "",
                status: "",
                dueDate: "",
                badgeColor: "light",
                note: "",
                alertRule: true,
                updatedAlert: new Date().toString(),
                alertType: "snooze",
              },
            },

            updated: new Date(),
            created_by: user.email,
            actived: true,
            expected: false,
            progressValue: 0,
            progressValue2: 0,
          });
          //axios.post("https://us-central1-parceiro-caixa.cloudfunctions.net/sendNotificationOfNewPorposal")
          //console.log("Proposta criada com sucesso!");
          commit("setProposal", { name: payload, id: doc.id });
          await dispatch("addNotification", {
            type: "new",
            created_by: state.user.uid,
            proposalName: payload.fullName,
            id: doc.id,
          });
          await dispatch("saveDocuments", doc.id);

          // await dispatch("getCommonBuyerTask")
          // await dispatch("addBuyerTask", { array: state.getCommonBuyerTaskList, id: doc.id });

          // await dispatch("getCommonSellerTask")
          // await dispatch("addSellerTask", { array: state.getCommonSellerTaskList, id: doc.id });

          // await dispatch("getCommonPropertyTask")
          // await dispatch("addPropertyTask", { array: state.getCommonPropertyTaskList, id: doc.id });
          //this.app.router.push('/habitacao');
          commit("setErrorMessage", {
            color: "success",
            text: "Proposta criada com sucesso!",
          });
          return true;
        } else {
          commit("setErrorMessage", {
            color: "danger",
            text: "Já existe proposta para esse CPF.",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async saveDocuments({ state, commit }, payload) {
      try {
        let storage = firebase.storage().ref();
        state.file.forEach(async (file) => {
          await storage.child(`${payload}/${file.name}`).put(file.file);
        });
        commit("setBlankFileArray", []);
        router.push({ name: "proposals" });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while save documents!",
        });
      }
    },

    listenersDataBase({ commit, dispatch, state }, payload) {
      db.collection("notifications").onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            let notification = change.doc.data();
            notification["notId"] = change.doc.id;
            commit("addNotificationData", notification);
          }
          if (change.type === "removed") {
            commit("removeNotificationState", change.doc.id);
          }
        });
      });
    },

    // getModifiedProposals({commit}){

    //   commit('setDataPreloader', true)

    //   db.collection('proposals')
    //   .where("actived", "==", true)
    //   .where("expected", "==", true)
    //   .where("steps.contract.status", "==", "Evoluída")
    //   .orderBy('progressValue')
    //   .limit(10)
    //   .onSnapshot( querySnapshot => {

    //     const proposals = []

    //     querySnapshot.forEach( doc => {
    //       let proposal = doc.data();
    //       proposal.id = doc.id;
    //       proposals.push(proposal)
    //     })

    //     commit('setProposals', proposals)
    //     commit('setDataPreloader', false)
    //   })
    // },

    // Get collection
    async getProposals({ state, commit }, req) {
      // Variables used to search for proposals in the firebase for the authenticated user.
      var searchType = "";
      var searchParam = "";
      let userId = "";

      // Replaces user information with recorded / updated db
      await db
        .collection("profileUsers")
        .doc(state.user.uid) //3WkjjmEg7tYEXNYOpK4EWL67knB2 state.user.uid
        .get()
        .then((doc) => {
          let usuario = doc.data();
          usuario.id = doc.id;
          userId = doc.id;
          commit("setUser", usuario);
        });

      if (state.user.level == "Agência") {
        var searchType = "bankBranch";
        var searchParam = state.user.linked;
      } else if (state.user.level == "Usuário") {
        var searchType = "created_by";
        var searchParam = state.user.email;
      }
      // else if (state.user.level == "Admin") {
      //   var searchType = "actived";
      //   var searchParam = true;
      // }

      // console.log(searchType);
      // console.log(searchParam);

      let proposals = [];
      let proposalsArr;
      commit("setDataPreloader", true);
      if (req.tabIndex === 0) {
        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("expected", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Conforme",
              "Com exigência",
              "Reenviada",
              "Agendada",
              // "Contratada",
              "",
            ])
            .orderBy("progressValue", "desc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("actived", "==", true)
            .where("expected", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Conforme",
              "Com exigência",
              "Reenviada",
              "Agendada",
              // "Contratada",
              "",
            ])
            .orderBy("progressValue", "desc");
        }
        proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "progressValue");
          commit("setconfigsOrder_proposal", "desc");
          commit("setDataPreloader", false);
        });
        //shared proposals
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("expected", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Conforme",
              "Com exigência",
              "Reenviada",
              "Agendada",
              // "Contratada",
              "",
            ])
            .orderBy("progressValue", "desc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
      } else if (req.tabIndex === 1) {
        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Conforme",
              "Com exigência",
              "Reenviada",
              "Agendada",
              "Contratada",
              "",
            ])
            .orderBy("progressValue", "desc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("actived", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Conforme",
              "Com exigência",
              "Reenviada",
              "Agendada",
              "Contratada",
              "",
            ])
            .orderBy("progressValue", "desc");
        }
        proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "progressValue");
          commit("setconfigsOrder_proposal", "desc");
          commit("setDataPreloader", false);
        });
        //shared proposals
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Conforme",
              "Com exigência",
              "Reenviada",
              "Agendada",
              "Contratada",
              "",
            ])
            .orderBy("progressValue", "desc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
      } else if (req.tabIndex === 2) {
        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("steps.riskAssessment.actived", "==", false)
            .orderBy("created", "desc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("actived", "==", true)
            .where("steps.riskAssessment.actived", "==", false)
            .orderBy("created", "desc");
        }
        await proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "created");
          commit("setconfigsOrder_proposal", "desc");
          commit("setDataPreloader", false);
        });
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("steps.riskAssessment.actived", "==", false)
            .orderBy("created", "desc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
      } else if (req.tabIndex === 3) {
        // let allProposals =  await db.collection('proposals').get()
        // commit('setAllProposals', allProposals)

        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("steps.engineering.actived", "==", false)
            .where("steps.riskAssessment.status", "in", [
              "Aprovado",
              "Condicionado",
            ])
            .orderBy("created", "desc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("actived", "==", true)
            .where("steps.engineering.actived", "==", false)
            .where("steps.riskAssessment.status", "in", [
              "Aprovado",
              "Condicionado",
            ])
            .orderBy("created", "desc");
        }
        proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "created");
          commit("setconfigsOrder_proposal", "desc");
          commit("setDataPreloader", false);
        });
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("actived", "==", true)
            .where("steps.engineering.actived", "==", false)
            .where("steps.riskAssessment.status", "in", [
              "Aprovado",
              "Condicionado",
            ])
            .orderBy("created", "desc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
        // query = query.limit(10)
        // const listSnapshot = await query.get()

        // if (listSnapshot.empty) {
        //   return ''
        // }

        // Check if next offset exists
        // const snapshotEndIndex = await db.collection('proposals')
        // .doc(listSnapshot.docs[listSnapshot.docs.length - 1].id)
        // .get()

        // console.log(snapshotEndIndex.data(), 'object')

        // if (snapshotEndIndex.exists) {
        //   const snapshotNextOffset = await db.collection('proposals')
        //     .startAfter(snapshotEndIndex)
        //     .limit(10)
        //     console.log(snapshotEndIndex, 'snapshotEndIndex', listSnapshot.docs[listSnapshot.docs.length - 1]);

        //   if (!snapshotNextOffset.empty) {
        //     snapshotNextOffset.onSnapshot(snapshot => {
        //       snapshot.forEach(doc => {
        //         let proposal = doc.data();
        //         proposal.id = doc.id;
        //         proposals.push(proposal)
        //       });
        //     })
        //   } else {
        //     console.log('empty')
        //   }
        // }
        // listSnapshot.docs.forEach(doc => {
        //   let proposal = doc.data();
        //         proposal.id = doc.id;
        //         proposals.push(proposal)
        //       })
        //   commit('setcondfigOrderBy_proposal', 'created')
        //   commit('setconfigsOrder_proposal', 'asc')
        //   commit('setDataPreloader', false)
        //  console.log(proposals, 'lolo')
      } else if (req.tabIndex === 4) {
        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("expected", "==", false)
            .where("steps.engineering.actived", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Conforme",
              "Com exigência",
              "Reenviada",
              "",
            ])
            .orderBy("progressValue", "desc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            //.where("created_by", "==", state.user.email)
            .where(searchType, "==", searchParam)
            .where("actived", "==", true)
            .where("expected", "==", false)
            .where("steps.engineering.actived", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Conforme",
              "Com exigência",
              "Reenviada",
              "",
            ])
            .orderBy("progressValue", "desc");
        }
        proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "progressValue");
          commit("setconfigsOrder_proposal", "desc");
          commit("setDataPreloader", false);
        });
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("expected", "==", false)
            .where("steps.engineering.actived", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Conforme",
              "Com exigência",
              "Reenviada",
              "",
            ])
            .orderBy("progressValue", "desc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
      } else if (req.tabIndex === 5) {
        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("steps.contract.actived", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Com exigência",
              "Reenviada",
            ])
            .orderBy("updated", "desc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("actived", "==", true)
            .where("steps.contract.actived", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Com exigência",
              "Reenviada",
            ])
            .orderBy("updated", "desc");
        }
        proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "updated");
          commit("setconfigsOrder_proposal", "desc");
          commit("setDataPreloader", false);
        });
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("actived", "==", true)
            .where("steps.contract.actived", "==", true)
            .where("steps.contract.status", "in", [
              "Enviando",
              "Enviado",
              "Com exigência",
              "Reenviada",
            ])
            .orderBy("updated", "desc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
      } else if (req.tabIndex === 6) {
        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("steps.contract.status", "in", ["Contratada", "Evoluída"])
            .orderBy("updated", "desc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("steps.contract.status", "in", ["Contratada", "Evoluída"])
            .orderBy("updated", "desc");
        }
        proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "updated");
          commit("setconfigsOrder_proposal", "desc");
          commit("setDataPreloader", false);
        });
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where("steps.contract.status", "in", ["Contratada", "Evoluída"])
            .orderBy("updated", "desc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
      } else if (req.tabIndex === 7) {
        if (state.selectedPendingOption === "Risk Assessment") {
          if (state.user.level == "Admin") {
            proposalsArr = await db
              .collection("proposals")
              .where("actived", "==", true)
              .where("steps.riskAssessment.status", "in", [
                "Com restrição",
                "Com pendência(s)",
                "Com restrição e Com pendência(s)",
              ])
              .orderBy("updated", "desc");
          } else {
            proposalsArr = await db
              .collection("proposals")
              .where("actived", "==", true)
              .where(searchType, "==", searchParam)
              .where("steps.riskAssessment.status", "in", [
                "Com restrição",
                "Com pendência(s)",
                "Com restrição e Com pendência(s)",
              ])
              .orderBy("updated", "desc");
          }
          proposalsArr.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let proposal = doc.data();
              proposal.id = doc.id;
              proposals.push(proposal);
            });
            commit("setcondfigOrderBy_proposal", "updated");
            commit("setconfigsOrder_proposal", "desc");
            commit("setDataPreloader", false);
          });
          if (state.user.level !== "Admin") {
            await db
              .collection("proposals")
              .where("actived", "==", true)
              .where("steps.riskAssessment.status", "in", [
                "Com restrição",
                "Com pendência(s)",
                "Com restrição e Com pendência(s)",
              ])
              .orderBy("updated", "desc")
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  let proposal = doc.data();
                  if (
                    proposal.shareWith &&
                    proposal.shareWith.includes(userId)
                  ) {
                    proposal.id = doc.id;
                    proposals.push(proposal);
                  }
                });
              });
          }
        } else if (state.selectedPendingOption === "Engineering") {
          if (state.user.level == "Admin") {
            proposalsArr = await db
              .collection("proposals")
              .where("steps.engineering.status", "==", "Pept")
              .orderBy("updated", "asc");
          } else {
            proposalsArr = await db
              .collection("proposals")
              .where(searchType, "==", searchParam)
              .where("steps.engineering.status", "==", "Pept")
              .orderBy("updated", "asc");
          }
          proposalsArr.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let proposal = doc.data();
              proposal.id = doc.id;
              proposals.push(proposal);
            });
            commit("setcondfigOrderBy_proposal", "updated");
            commit("setconfigsOrder_proposal", "asc");
            commit("setDataPreloader", false);
          });
          if (state.user.level !== "Admin") {
            await db
              .collection("proposals")
              .where("steps.engineering.status", "==", "Pept")
              .orderBy("updated", "asc")
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  let proposal = doc.data();
                  if (
                    proposal.shareWith &&
                    proposal.shareWith.includes(userId)
                  ) {
                    proposal.id = doc.id;
                    proposals.push(proposal);
                  }
                });
              });
          }
        } else if (
          state.selectedPendingOption === "Risk Assessment & Engineering"
        ) {
          if (state.user.level == "Admin") {
            proposalsArr = await db
              .collection("proposals")
              .where("steps.riskAssessment.status", "in", [
                "Com restrição",
                "Com pendência(s)",
                "Com restrição e Com pendência(s)",
              ])
              .where("steps.engineering.status", "==", "Pept")
              .orderBy("updated", "asc");
          } else {
            proposalsArr = await db
              .collection("proposals")
              .where(searchType, "==", searchParam)
              .where("steps.riskAssessment.status", "in", [
                "Com restrição",
                "Com pendência(s)",
                "Com restrição e Com pendência(s)",
              ])
              .where("steps.engineering.status", "==", "Pept")
              .orderBy("updated", "asc");
          }
          proposalsArr.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let proposal = doc.data();
              proposal.id = doc.id;
              proposals.push(proposal);
            });
            commit("setcondfigOrderBy_proposal", "updated");
            commit("setconfigsOrder_proposal", "asc");
            commit("setDataPreloader", false);
          });
          if (state.user.level !== "Admin") {
            await db
              .collection("proposals")
              .where("steps.riskAssessment.status", "in", [
                "Com restrição",
                "Com pendência(s)",
                "Com restrição e Com pendência(s)",
              ])
              .where("steps.engineering.status", "==", "Pept")
              .orderBy("updated", "asc")
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  let proposal = doc.data();
                  if (
                    proposal.shareWith &&
                    proposal.shareWith.includes(userId)
                  ) {
                    proposal.id = doc.id;
                    proposals.push(proposal);
                  }
                });
              });
          }
        }
      } else if (req.tabIndex === 8) {
        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("steps.riskAssessment.status", "==", "Reprovada")
            .orderBy("updated", "asc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("steps.riskAssessment.status", "==", "Reprovada")
            .orderBy("updated", "asc");
        }
        proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "updated");
          commit("setconfigsOrder_proposal", "asc");
          commit("setDataPreloader", false);
        });
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where("steps.riskAssessment.status", "==", "Reprovada")
            .orderBy("updated", "asc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
      } else if (req.tabIndex === 9) {
        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("actived", "==", false)
            .orderBy("created", "asc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("actived", "==", false)
            .orderBy("created", "asc");
        }
        proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "created");
          commit("setconfigsOrder_proposal", "asc");
          commit("setDataPreloader", false);
        });
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where("actived", "==", false)
            .orderBy("created", "asc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
      } else if (req.tabIndex === 10) {
        if (req.globalTabType === "search") {
          const cpf = /[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}/;
          var matches = state.globalSearchData.match(cpf);
          if (matches == null) {
            if (state.user.level == "Admin") {
              proposalsArr = await db
                .collection("proposals")
                .orderBy("name")
                .startAt(state.globalSearchData.toUpperCase())
                .endAt(state.globalSearchData.toUpperCase() + "\uf8ff");
            } else {
              proposalsArr = await db
                .collection("proposals")
                .orderBy("name")
                .where(searchType, "==", searchParam)
                .startAt(state.globalSearchData.toUpperCase())
                .endAt(state.globalSearchData.toUpperCase() + "\uf8ff");
            }
            proposalsArr.get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                proposal.id = doc.id;
                proposals.push(proposal);
              });
              commit("setcondfigOrderBy_proposal", "progressValue");
              commit("setconfigsOrder_proposal", "desc");
              commit("setDataPreloader", false);
            });
            if (state.user.level !== "Admin") {
              await db
                .collection("proposals")
                .orderBy("name")
                .startAt(state.globalSearchData.toUpperCase())
                .endAt(state.globalSearchData.toUpperCase() + "\uf8ff")
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    let proposal = doc.data();
                    if (
                      proposal.shareWith &&
                      proposal.shareWith.includes(userId)
                    ) {
                      proposal.id = doc.id;
                      proposals.push(proposal);
                    }
                  });
                });
            }
          } else {
            if (state.user.level == "Admin") {
              proposalsArr = await db
                .collection("proposals")
                .where("cpf", "==", state.globalSearchData);
            } else {
              proposalsArr = await db
                .collection("proposals")
                .where("cpf", "==", state.globalSearchData)
                .where(searchType, "==", searchParam);
            }
            proposalsArr.get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                proposal.id = doc.id;
                proposals.push(proposal);
              });
            });
            if (state.user.level !== "Admin") {
              await db
                .collection("proposals")
                .where("cpf", "==", state.globalSearchData)
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    let proposal = doc.data();
                    if (
                      proposal.shareWith &&
                      proposal.shareWith.includes(userId)
                    ) {
                      proposal.id = doc.id;
                      proposals.push(proposal);
                    }
                  });
                });
            }
            commit("setcondfigOrderBy_proposal", "progressValue");
            commit("setconfigsOrder_proposal", "desc");
            // commit("setDataPreloader", false);
            // });
          }
        } else if (req.globalTabType === "alert") {
          proposalsArr = await db
            .collection("proposals")
            .where("actived", "==", true)
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                proposal.id = doc.id;
                let currentDate = moment();
                let currentDateStart = moment().startOf("day");
                var today = new Date();
                var updatedDate = proposal.updated.toDate();
                var diff = today.getTime() - updatedDate.getTime();
                // contract
                const contractDueDate = moment(
                  `${proposal.steps.contract.dueDate}`
                );
                const contractDiff = moment.duration(
                  currentDate.diff(contractDueDate)
                );
                const contractDate = Math.ceil(contractDiff.asDays());
                const contractUpdateDate = moment(
                  `${proposal.steps.contract.updatedAlert}`
                );
                const contractUpdateDiff = moment.duration(
                  currentDate.diff(contractUpdateDate)
                );
                const contractAlertDiffInHr = contractUpdateDiff.asHours();
                const contractUpdateStartDate = moment(
                  `${proposal.steps.contract.updatedAlert}`
                ).startOf("day");
                let contractForSnooze;
                let contractForOk;
                let engineeringForSnooze;
                let engineeringForOk;
                let formsForSnooze;
                let formsForOk;
                let fgtsForSnooze;
                let fgtsForOk;
                if (
                  contractAlertDiffInHr > 3 &&
                  proposal.steps.contract.alertType === "snooze"
                ) {
                  contractForSnooze = true;
                }
                if (
                  currentDateStart.diff(contractUpdateStartDate, "days") >= 1 &&
                  proposal.steps.contract.alertType === "ok"
                ) {
                  contractForOk = true;
                }
                // engineering
                const engineeringDueDate = moment(
                  `${proposal.steps.engineering.dueDate}`
                );
                const engineeringDiff = moment.duration(
                  currentDate.diff(engineeringDueDate)
                );
                const engineeringDate = Math.ceil(engineeringDiff.asDays());
                console.log(engineeringDate, "engineeringDateengineeringDate");
                const engineeringUpdateDate = moment(
                  `${proposal.steps.engineering.updatedAlert}`
                );
                const engineeringUpdateStartDate = moment(
                  `${proposal.steps.engineering.updatedAlert}`
                ).startOf("day");
                const engineeringUpdateDiff = moment.duration(
                  currentDate.diff(engineeringUpdateDate)
                );
                const engineeringAlertDiffInHr = engineeringUpdateDiff.asHours();
                if (
                  engineeringAlertDiffInHr > 3 &&
                  proposal.steps.engineering.alertType === "snooze"
                ) {
                  engineeringForSnooze = true;
                }
                if (
                  currentDateStart.diff(engineeringUpdateStartDate, "days") >=
                    1 &&
                  proposal.steps.engineering.alertType === "ok"
                ) {
                  engineeringForOk = true;
                }
                // forms
                const formsUpdateDate = moment(
                  `${proposal.steps.forms.updatedAlert}`
                );
                const formsUpdateStartDate = moment(
                  `${proposal.steps.forms.updatedAlert}`
                ).startOf("day");
                const formsUpdateDiff = moment.duration(
                  currentDate.diff(formsUpdateDate)
                );
                const formsDueDate = moment(`${proposal.steps.forms.dueDate}`);
                const formsDiff = moment.duration(
                  currentDate.diff(formsDueDate)
                );
                const formsDate = Math.ceil(formsDiff.asDays());
                const formsAlertDiffInHr = formsUpdateDiff.asHours();
                this.formsAlertDiffInHr = formsAlertDiffInHr;
                if (
                  formsAlertDiffInHr > 3 &&
                  proposal.steps.forms.alertType === "snooze"
                ) {
                  formsForSnooze = true;
                }
                if (
                  currentDateStart.diff(formsUpdateStartDate, "days") >= 1 &&
                  proposal.steps.forms.alertType === "ok"
                ) {
                  formsForOk = true;
                }
                // fgts
                const fgtsDueDate = moment(`${proposal.steps.fgts.dueDate}`);
                const fgtsDiff = moment.duration(currentDate.diff(fgtsDueDate));
                const fgtsDate = Math.ceil(fgtsDiff.asDays());
                const fgtsUpdateDate = moment(
                  `${proposal.steps.fgts.updatedAlert}`
                );
                const fgtsUpdateStartDate = moment(
                  `${proposal.steps.fgts.updatedAlert}`
                ).startOf("day");
                const fgtsUpdateDiff = moment.duration(
                  currentDate.diff(fgtsUpdateDate)
                );
                const fgtsAlertDiffInHr = fgtsUpdateDiff.asHours();
                if (
                  fgtsAlertDiffInHr > 3 &&
                  proposal.steps.fgts.alertType === "snooze"
                ) {
                  fgtsForSnooze = true;
                }
                if (
                  currentDateStart.diff(fgtsUpdateStartDate, "days") >= 1 &&
                  proposal.steps.fgts.alertType === "ok"
                ) {
                  fgtsForOk = true;
                }

                // Bloqueia a atenção para as propostas já EVOLUÍDAS.
                if (
                  proposal.steps.contract.actived &&
                  proposal.steps.contract.situation == "Emitida" &&
                  proposal.steps.contract.status == "Agendada" &&
                  contractDate >= 1 &&
                  proposal.steps.contract.alertRule &&
                  (contractForSnooze || contractForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.contract.actived &&
                  proposal.steps.contract.situation == "Emitida" &&
                  proposal.steps.contract.status == "Contratada" &&
                  contractDate >= 1 &&
                  proposal.steps.contract.alertRule &&
                  (contractForSnooze || contractForOk)
                ) {
                  return proposals.push(proposal);
                }
                // Chama a atenção para as propostas da fase de ESCRITURA que não estão na situação EVOUÍDA e que não houve atualiação em 2 dia.
                else if (
                  proposal.steps.contract.actived &&
                  proposal.steps.contract.situation ==
                    "Em análise de conformidade" &&
                  proposal.steps.contract.status == "Enviando" &&
                  contractUpdateDiff.asDays() >= 3 &&
                  proposal.steps.contract.alertRule &&
                  (contractForSnooze || contractForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.contract.actived &&
                  proposal.steps.contract.situation ==
                    "Em análise de conformidade" &&
                  proposal.steps.contract.status == "Enviado" &&
                  contractDate >= 2 &&
                  proposal.steps.contract.alertRule &&
                  (contractForSnooze || contractForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.contract.actived &&
                  proposal.steps.contract.situation ==
                    "Em análise de conformidade" &&
                  proposal.steps.contract.status == "Conforme" &&
                  contractDate >= 2 &&
                  proposal.steps.contract.alertRule &&
                  (contractForSnooze || contractForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.contract.actived &&
                  proposal.steps.contract.situation ==
                    "Em análise de conformidade" &&
                  proposal.steps.contract.status == "Com exigência" &&
                  contractDate >= 2 &&
                  (contractForSnooze || contractForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.contract.actived &&
                  proposal.steps.contract.situation ==
                    "Em análise de conformidade" &&
                  proposal.steps.contract.status == "Reenviada" &&
                  contractDate >= 1 &&
                  (contractForSnooze || contractForOk)
                ) {
                  return proposals.push(proposal);
                }
                // Chama a atenção para as propostas da fase de ESCRITURA que não estão na situação EVOUÍDA e que não houve atualiação em 2 dia.

                // Chama a atenção para as propostas da fase de FGTS que não estão no status RESSARCIDA e que não houve atualiação em 1 dia.
                else if (
                  proposal.steps.fgts.actived &&
                  proposal.steps.fgts.situation == "Cadastrado" &&
                  fgtsDate >= 2 &&
                  (fgtsForSnooze || fgtsForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.fgts.actived &&
                  proposal.steps.fgts.situation == "Solicitado" &&
                  proposal.steps.fgts.status ==
                    "Liberação de ressarcimento solicitada em" &&
                  fgtsDate >= 3 &&
                  (fgtsForSnooze || fgtsForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.fgts.actived &&
                  proposal.steps.fgts.situation == "Solicitado" &&
                  proposal.steps.fgts.status == "Com erro" &&
                  fgtsDate >= 2 &&
                  (fgtsForSnooze || fgtsForOk)
                ) {
                  return proposals.push(proposal);
                }
                // Chama a atenção para as propostas da fase de FORMULÁRIOS que estão na situação de ENVIADOS ou com o status INCONFORME e que não houve atualiação em 2 dia.
                else if (
                  proposal.steps.forms.actived &&
                  proposal.steps.forms.situation == "Emitidos" &&
                  formsDate >= 1 &&
                  (formsForSnooze || formsForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.forms.actived &&
                  proposal.steps.forms.situation == "Enviados" &&
                  formsDate > 2 &&
                  (formsForSnooze || formsForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.forms.actived &&
                  proposal.steps.forms.situation === "Recebidos" &&
                  proposal.steps.forms.status === "Inconforme" &&
                  formsDate >= 2 &&
                  (formsForSnooze || formsForOk)
                ) {
                  return proposals.push(proposal);
                }
                // Chama a atenção para as propostas da fase de ENGENHARIA com STIUAÇÃO em BOLETO/CONVOCADA/EMITIDA que não houve atualiação nos respectivos prazos.
                else if (
                  proposal.steps.engineering.actived &&
                  proposal.steps.engineering.situation == "Boleto" &&
                  engineeringDate >= 1 &&
                  (engineeringForSnooze || engineeringForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.engineering.actived &&
                  proposal.steps.engineering.situation == "Convocada" &&
                  engineeringDate >= 1 &&
                  (engineeringForSnooze || engineeringForOk)
                ) {
                  return proposals.push(proposal);
                } else if (
                  proposal.steps.engineering.actived &&
                  proposal.steps.engineering.situation == "Emitida" &&
                  engineeringDate >= 4 &&
                  (engineeringForSnooze || engineeringForOk)
                ) {
                  return proposals.push(proposal);
                } else {
                  return false;
                }
              });
            });
        }
      } else if (req.tabIndex === 11) {
        if (state.user.level == "Admin") {
          proposalsArr = await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("steps.riskAssessment.situation", "==", "Em análise")
            .orderBy("created", "desc");
        } else {
          proposalsArr = await db
            .collection("proposals")
            .where(searchType, "==", searchParam)
            .where("actived", "==", true)
            .where("steps.riskAssessment.situation", "==", "Em análise")
            .orderBy("created", "desc");
        }
        proposalsArr.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
          commit("setcondfigOrderBy_proposal", "progressValue");
          commit("setconfigsOrder_proposal", "desc");
          commit("setDataPreloader", false);
        });
        if (state.user.level !== "Admin") {
          await db
            .collection("proposals")
            .where("actived", "==", true)
            .where("steps.riskAssessment.situation", "==", "Em análise")
            .orderBy("progressValue", "desc")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let proposal = doc.data();
                if (proposal.shareWith && proposal.shareWith.includes(userId)) {
                  proposal.id = doc.id;
                  proposals.push(proposal);
                }
              });
            });
        }
      }

      console.log(proposals, "proposalsproposalsproposalsproposals");

      commit("setDataPreloader", false);
      commit("setProposals", proposals);
    },

    async getAllproposals({ commit }) {
      try {
        let allProposals = [];
        await db
          .collection("proposals")
          .get()
          .then((proposals) => {
            for (const proposal of proposals.docs) {
              allProposals.push(proposal.data());
            }
          });
        commit("setAllProposals", allProposals);
      } catch (e) {
        console.log(e);
      }
    },

    async getAtendimentoProposals({ commit }) {
      try {
        let proposals = [];
        await db
          .collection("proposals")
          .where("actived", "==", true)
          .where("steps.riskAssessment.situation", "==", "Em análise")
          .orderBy("created", "desc")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let proposal = doc.data();
              proposal.id = doc.id;
              proposals.push(proposal);
            });
          });
        commit("setAtendimentoProposals", proposals);
      } catch (e) {
        console.log(e, "error");
      }
    },

    async getNewProposals({ state, commit }) {
      let proposals = [];
      await db
        .collection("proposals")
        .where("actived", "==", true)
        .where("steps.riskAssessment.actived", "==", false)
        .orderBy("created", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            proposals.push(proposal);
          });
        });
      state.newProposalsLength = proposals.length;
    },
    async getChartNewProposals({ state, commit }, period) {
      const startTime = new Date(period.start).getTime();
      const endTime = new Date(period.end).getTime();
      let proposals = [];
      await db
        .collection("proposals")
        .where("actived", "==", true)
        .where("steps.riskAssessment.actived", "==", false)
        .orderBy("created", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            const createdDate = new Date(proposal.created.toDate());
            if (
              startTime <= createdDate &&
              createdDate <= endTime &&
              proposal.actived
            ) {
              proposals.push(proposal);
            }
          });
        });
      state.newChartProposalsLength = proposals.length;
    },
    async getChartInserviceProposals({ state, commit }, period) {
      const startTime = new Date(period.start).getTime();
      const endTime = new Date(period.end).getTime();
      let proposals = [];
      await db
        .collection("proposals")
        .where("actived", "==", true)
        .where("steps.riskAssessment.situation", "==", "Em análise")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let proposal = doc.data();
            proposal.id = doc.id;
            const createdDate = new Date(proposal.created.toDate());
            if (
              startTime <= createdDate &&
              createdDate <= endTime &&
              proposal.actived
            ) {
              proposals.push(proposal);
            }
          });
        });
      state.inServiceProposalsLength = proposals.length;
    },
    async getProposalsDataForCalculation({ state, commit }, req) {
      let proposals;
      let proposalArr = [];
      const startTime = new Date(req.period.start).getTime();
      const endTime = new Date(req.period.end).getTime();
      if (req.filterBy === "Estoque") {
        const estoque = db
          .collection("proposals")
          .where("actived", "==", true)
          .where("steps.engineering.actived", "==", false)
          .where("steps.riskAssessment.status", "in", [
            "Aprovado",
            "Condicionado",
          ])
          .orderBy("created", "asc")
          .get();
        const estoqueQuerySnapshot = await estoque;
        proposals = estoqueQuerySnapshot.docs;

        const approved = db
          .collection("proposals")
          // .where("steps.engineering.actived", "==", false)
          .where("steps.riskAssessment.status", "in", [
            "Aprovado",
            "Condicionado",
          ])
          .orderBy("created", "asc")
          .get();

        const pending = db
          .collection("proposals")
          // .where("actived", "==", true)
          .where("steps.riskAssessment.status", "in", [
            "Com restrição",
            "Com pendência(s)",
            "Com restrição e Com pendência(s)",
          ])
          .orderBy("created", "asc")
          .get();

        const inactive = db
          .collection("proposals")
          .where("actived", "==", false)
          .orderBy("created", "asc")
          .get();

        const [
          approvedQuerySnapshot,
          pendingQuerySnapshot,
          inactiveQuerySnapshot,
        ] = await Promise.all([approved, pending, inactive]);

        const approvedArr = approvedQuerySnapshot.docs;
        const pendingArr = pendingQuerySnapshot.docs;
        const inactiveArr = inactiveQuerySnapshot.docs;

        state.approvedArr = [];
        approvedArr.forEach((doc) => {
          let proposal = doc.data();
          proposal.id = doc.id;
          const createdDate = new Date(proposal.created.toDate());
          if (startTime <= createdDate && createdDate <= endTime) {
            state.approvedArr.push(proposal);
          }
        });

        state.approvedArr.sort(function(a, b) {
          return a.created.seconds - b.created.seconds;
        });

        state.pendingArr = [];
        pendingArr.forEach((element) => {
          let proposal = element.data();
          const createdDate = new Date(proposal.created.toDate());
          if (
            startTime <= new Date(createdDate).getTime() &&
            new Date(createdDate).getTime() <= endTime
          ) {
            state.pendingArr.push(proposal);
          }
        });

        state.inactiveArr = [];
        inactiveArr.forEach((element) => {
          let proposal = element.data();
          const createdDate = new Date(proposal.created.toDate());
          if (
            startTime <= new Date(createdDate).getTime() &&
            new Date(createdDate).getTime() <= endTime
          ) {
            state.inactiveArr.push(proposal);
          }
        });
      } else if (req.filterBy === "Fluxo") {
        const progress = db
          .collection("proposals")
          .where("actived", "==", true)
          // .where("expected", "==", false)
          .where("steps.engineering.actived", "==", true)
          .where("steps.contract.status", "in", [
            "Enviando",
            "Enviado",
            "Conforme",
            "Com exigência",
            "Reenviada",
            "",
          ])
          .orderBy("created", "asc")
          .get();

        const contracted = await db
          .collection("proposals")
          .where("steps.contract.status", "in", ["Contratada", "Evoluída"])
          .orderBy("created", "asc")
          .get();

        const approved = db
          .collection("proposals")
          // .where("steps.engineering.actived", "==", false)
          .where("steps.riskAssessment.status", "in", [
            "Aprovado",
            "Condicionado",
          ])
          .orderBy("created", "asc")
          .get();

        const allProposals = db
          .collection("proposals")
          .orderBy("created", "asc")
          .get();

        const failed = db
          .collection("proposals")
          // .where("actived", "==", true)
          .where("steps.riskAssessment.status", "==", "Reprovada")
          .orderBy("created", "asc")
          .get();

        const pending = db
          .collection("proposals")
          // .where("actived", "==", true)
          .where("steps.riskAssessment.status", "in", [
            "Com restrição",
            "Com pendência(s)",
            "Com restrição e Com pendência(s)",
          ])
          .orderBy("created", "asc")
          .get();

        const inactive = db
          .collection("proposals")
          .where("actived", "==", false)
          .orderBy("created", "asc")
          .get();

        const [
          progressQuerySnapshot,
          contractedQuerySnapshot,
          approvedQuerySnapshot,
          allProposalsQuerySnapshot,
          failedQuerySnapshot,
          pendingQuerySnapshot,
          inactiveQuerySnapshot,
        ] = await Promise.all([
          progress,
          contracted,
          approved,
          allProposals,
          failed,
          pending,
          inactive,
        ]);

        const progressArr = progressQuerySnapshot.docs;
        const contractedArr = contractedQuerySnapshot.docs;
        const approvedArr = approvedQuerySnapshot.docs;
        proposals = allProposalsQuerySnapshot.docs;
        const failedArr = failedQuerySnapshot.docs;
        const pendingArr = pendingQuerySnapshot.docs;
        const inactiveArr = inactiveQuerySnapshot.docs;

        // let allApprovedArr = [...approvedArr, ...contractedArr, ...progressArr]

        state.approvedArr = [];
        approvedArr.forEach((doc) => {
          let proposal = doc.data();
          proposal.id = doc.id;
          const createdDate = new Date(proposal.created.toDate());
          if (startTime <= createdDate && createdDate <= endTime) {
            state.approvedArr.push(proposal);
          }
        });

        state.approvedArr.sort(function(a, b) {
          return a.created.seconds - b.created.seconds;
        });

        state.contractedArr = [];
        contractedArr.forEach((element) => {
          let proposal = element.data();
          const createdDate = new Date(proposal.created.toDate());
          if (
            startTime <= new Date(createdDate).getTime() &&
            new Date(createdDate).getTime() <= endTime
          ) {
            state.contractedArr.push(proposal);
          }
        });

        state.pendingArr = [];
        pendingArr.forEach((element) => {
          let proposal = element.data();
          const createdDate = new Date(proposal.created.toDate());
          if (
            startTime <= new Date(createdDate).getTime() &&
            new Date(createdDate).getTime() <= endTime
          ) {
            state.pendingArr.push(proposal);
          }
        });

        console.log(state.pendingArr, "state.pendingArr.pendingArr.pendingArr");

        state.failedArr = [];
        failedArr.forEach((element) => {
          let proposal = element.data();
          const createdDate = new Date(proposal.created.toDate());
          if (
            startTime <= new Date(createdDate).getTime() &&
            new Date(createdDate).getTime() <= endTime
          ) {
            state.failedArr.push(proposal);
          }
        });

        console.log(
          state.failedArr,
          "state.failedArrstate.failedArrstate.failedArr"
        );

        state.progressArr = [];
        progressArr.forEach((element) => {
          let proposal = element.data();
          const createdDate = new Date(proposal.created.toDate());
          if (
            startTime <= new Date(createdDate).getTime() &&
            new Date(createdDate).getTime() <= endTime
          ) {
            state.progressArr.push(proposal);
          }
        });

        state.inactiveArr = [];
        inactiveArr.forEach((element) => {
          let proposal = element.data();
          const createdDate = new Date(proposal.created.toDate());
          if (
            startTime <= new Date(createdDate).getTime() &&
            new Date(createdDate).getTime() <= endTime
          ) {
            state.inactiveArr.push(proposal);
          }
        });
      } else if (req.filterBy === "Resultado") {
        const contratadas = db
          .collection("proposals")
          .where("steps.contract.status", "in", ["Contratada", "Evoluída"])
          .orderBy("created", "asc")
          .get();
        const contratadasQuerySnapshot = await contratadas;
        proposals = contratadasQuerySnapshot.docs;
      }
      proposals.forEach((doc) => {
        let proposal = doc.data();
        proposal.id = doc.id;
        proposalArr.push(proposal);
      });

      proposalArr.sort((a, b) => {
        return a.created.seconds - b.created.seconds;
      });

      let filteredByPeriod = [];
      proposalArr.forEach((element) => {
        if (req.filterBy === "Resultado") {
          const approvedDate =
            moment(element.steps.contract.dueDate).format("X") * 1000;
          if (startTime <= approvedDate && approvedDate <= endTime) {
            filteredByPeriod.push(element);
          }
        } else {
          const createdDate = new Date(element.created.toDate());
          if (
            startTime <= new Date(createdDate).getTime() &&
            new Date(createdDate).getTime() <= endTime
          ) {
            filteredByPeriod.push(element);
          }
        }
      });
      await commit("setFilteredProposals", filteredByPeriod);
    },

    async getAprovadoCondicionadoRiskProposals() {
      try {
        const proposalsArr = [];
        await db
          .collection("proposals")
          .where("steps.riskAssessment.status", "in", [
            "Aprovado",
            "Condicionado",
          ])
          .get()
          .then((proposals) => {
            proposals.forEach((proposal) => {
              proposalsArr.push(proposal.data());
            });
          });
        return proposalsArr;
      } catch (e) {
        console.log(e);
      }
    },

    async getEvoluídaContractProposals() {
      try {
        const proposalsArr = [];
        await db
          .collection("proposals")
          .where("steps.contract.status", "==", "Evoluída")
          .get()
          .then((proposals) => {
            proposals.forEach((proposal) => {
              proposalsArr.push(proposal.data());
            });
          });
        return proposalsArr;
      } catch (e) {
        console.log(e);
      }
    },

    getProposal({ commit }, id) {
      commit("setDataPreloader", true);

      db.collection("proposals")
        .doc(id)
        .get()
        .then((doc) => {
          let proposal = doc.data();
          proposal.id = doc.id;
          // proposal.steps.note = proposal.steps.note.replaceAll("\\n", "\n");
          // console.log(proposal.steps.note, 'proposal.steps.note', doc.data().steps.note);
          proposal.steps.riskAssessment.color =
            proposal.steps.riskAssessment.badgeColor;
          proposal.steps.engineering.color =
            proposal.steps.engineering.badgeColor;
          proposal.steps.forms.color = proposal.steps.forms.badgeColor;
          proposal.steps.dossier.color = proposal.steps.dossier.badgeColor;
          proposal.steps.contract.color = proposal.steps.contract.badgeColor;
          proposal.steps.fgts.color = proposal.steps.fgts.badgeColor;
          commit("setProposal", proposal);
        });

      commit("setDataPreloader", false);
    },

    /*async riskAssessmentSituationHandler({ commit }, payload) {
      bootbox.prompt({
        title: "Avaliação de Risco",
        message: "<p>Selecione a situação que se escontra essa etapa:</p>",
        inputType: "radio",
        centerVertical: true,
        inputOptions: [
          {
            text: "Em análise",
            value: "underAnalysis",
          },
          {
            text: "Aprovado",
            value: "approved",
          },
          {
            text: "Condicionado",
            value: "conditioning",
          },
          {
            value: "disapproved",
            text: "Reprovado",
            color: "bg-danger",
          },
          {
            text: "Com Pendência(s)",
            value: "pending",
          },
        ],
        callback: function(result) {
          console.log(result);
          console.log(payload);

          try {
            db.collection("proposals")
              .doc(payload)
              .update({
                updated: new Date(),
                steps: {
                  riskAssessment: {
                    situation: {
                      value: result,
                    },
                  },
                },
              });
            console.log("Proposta Atualizada");
            commit("setError");
            commit("setErrorMessage", {
              color: "success",
              text: "Etapa Atualizada com sucesso!",
            });
          } catch (error) {
            console.log("Error ao adicionar o doc: ", error);
            commit("setError");
            commit("setErrorMessage", {
              color: "danger",
              text: "Opsss... Algo aconteceu!",
            });
          }
        },
      });
    },*/

    /*async riskAssessmentStatusHandler({ commit }, payload) {
      bootbox.confirm({
        title: "Avaliação de Risco",
        message:
          "<p>Você deseja enviar a notificação por e-mail dessa etapa para o cliente?<br>||| CLICAR EM CANCEL - MODELO EM TESTE ||| </p>",
        // message: "<p>O e-mail do cliente principal não foi definido. Se desejar prosseguir com a atualização da proposta clique em OK e anote nas tarefas para atualizar.</p>",
        centerVertical: true,
        callback: async function(result) {
          try {
            if (result) {
              const sendMailForRiskStatus = firebase
                .functions()
                .httpsCallable("sendMailForRiskStatus");
              sendMailForRiskStatus({
                riskStatus: payload.riskStatus,
                email: payload.email,
                cpf: payload.cpf,
                name: payload.name,
                email: payload.email,
                created_by: payload.created_by,
                riskAmount: payload.riskAmount,
                phoneNumber: payload.phoneNumber,
                propertyType: payload.propertyType,
                propertyCategory: payload.propertyCategory,
                intendedFinancingValue: payload.intendedFinancingValue,
                period: payload.period,
                amortizationSystem: payload.amortizationSystem,
                indexer: payload.indexer,
                propertyValue: payload.propertyValue,
                fgts: payload.fgts ? "Sim" : "Não",
              })
                .then((res) => {
                  console.log("%c --res", "color: #0088CC", res);
                })
                .catch((e) => {
                  console.log("%c --e", "color: #00BF00", e);
                });
              commit("setError");
              commit("setErrorMessage", {
                color: "success",
                text: "Mail sent successfully",
              });
            } else {
              commit("setError");
              commit("setErrorMessage", {
                color: "danger",
                text: "Mail not  sent",
              });
            }
          } catch (error) {
            console.log("Error ao adicionar o doc: ", error);
            commit("setError");
            commit("setErrorMessage", {
              color: "danger",
              text: "Opsss...!",
            });
          }
        },
      });
    },*/

    /*async contractStatusHandler({ commit }, payload) {
      bootbox.confirm({
        title: "For contract",
        message: "<p>Do you want to send mail ?</p>",
        centerVertical: true,
        callback: async function(result) {
          try {
            if (result) {
              const sendMailForRiskStatus = firebase
                .functions()
                .httpsCallable("sendMailForRiskStatus");
              sendMailForRiskStatus({
                riskStatus: payload.status,
                email: payload.email,
                cpf: payload.cpf,
                name: payload.name,
                email: payload.email,
                created_by: payload.created_by,
                riskAmount: payload.riskAmount,
              })
                .then((res) => {
                  console.log("%c --res", "color: #0088CC", res);
                })
                .catch((e) => {
                  console.log("%c --e", "color: #00BF00", e);
                });
              commit("setError");
              commit("setErrorMessage", {
                color: "success",
                text: "Mail sent successfully",
              });
            } else {
              commit("setError");
              commit("setErrorMessage", {
                color: "danger",
                text: "Mail not  sent",
              });
            }
          } catch (error) {
            console.log("Error ao adicionar o doc: ", error);
            commit("setError");
            commit("setErrorMessage", {
              color: "danger",
              text: "Opsss...!",
            });
          }
        },
      });
    },*/

    /*async engineeringStatusHandler({ commit }, payload) {
      bootbox.confirm({
        title: "For engineering",
        message: "<p>Do you want to send mail ?</p>",
        centerVertical: true,
        callback: async function(result) {
          try {
            if (result) {
              const sendMailForRiskStatus = firebase
                .functions()
                .httpsCallable("sendMailForRiskStatus");
              sendMailForRiskStatus({
                riskStatus: payload.status,
                email: payload.email,
                cpf: payload.cpf,
                name: payload.name,
                email: payload.email,
                created_by: payload.created_by,
                riskAmount: payload.riskAmount,
              })
                .then((res) => {
                  console.log("%c --res", "color: #0088CC", res);
                })
                .catch((e) => {
                  console.log("%c --e", "color: #00BF00", e);
                });
              commit("setError");
              commit("setErrorMessage", {
                color: "success",
                text: "Mail sent successfully",
              });
            } else {
              commit("setError");
              commit("setErrorMessage", {
                color: "danger",
                text: "Mail not  sent",
              });
            }
          } catch (error) {
            console.log("Error ao adicionar o doc: ", error);
            commit("setError");
            commit("setErrorMessage", {
              color: "danger",
              text: "Opsss...!",
            });
          }
        },
      });
    },*/

    async editProposal({ commit, dispatch, state }, payload, id) {
      if (
        payload.steps.engineering.situation === "Laudo" &&
        !payload.engineeringEvaluation
      ) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Incluir Valor de Avaliação de Engenharia",
        });
        return;
      }
      if (payload.steps.fgts.situation && !payload.fgtsValue) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Incluir Número da DAMP e Valor de FGTS",
        });
        return;
      }
      // Inclui essa bagaça aqui para poder enviar pelo menos os SMSs... Mas os SMSs não estavam chegando dando erro no Twilio - E como copiei o código da parte que comentei, ele está enviando msg toda vez que a proposta é atualizada
      // Ou seja comentei o código novamente para depois pensar com calma
      /*if (payload.steps.riskAssessment.status === "Aprovado" ) {
        try {
          const sendSmsForHandleProposalStatus = firebase
            .functions()
            .httpsCallable("sendSmsForHandleProposalStatus");
            sendSmsForHandleProposalStatus({
            riskStatus: payload.steps.riskAssessment.status,*/

            /*email: payload.email,
            cpf: payload.cpf,
            name: payload.name,
            created_by: payload.created_by,
            riskAmount: payload.approvedFinancingAmount,*/

            /*phoneNumber: payload.phoneNumber,*/

            /*propertyType: payload.propertyType,
            propertyCategory: payload.propertyCategory,
            intendedFinancingValue: payload.intendedFinancingValue,
            period: payload.period,
            amortizationSystem: payload.amortizationSystem,
            indexer: payload.indexer,
            propertyValue: payload.propertyValue,
            fgts: payload.fgts ? "Sim" : "Não",*/
            /*})
            .then((res) => {
              console.log("%c --res", "color: #0088CC", res);
            })
            .catch((e) => {
              console.log("%c --e", "color: #00BF00", e);
            });
          commit("setError");
          commit("setErrorMessage", {
            color: "success",
            text: "SMS sent successfully",
          });
        } catch (error) {
          console.log("Error ao adicionar o doc: ", error);
          commit("setError");
          commit("setErrorMessage", {
            color: "danger",
            text: "Opsss...!",
          });
        }
      }*/

      // DAQUI PARA BAIXO JÁ INICIA O CÓDIGO ORIGINAL DE ENVIO DE E-MAIL PARA O CLIENTE.
      /*if (
        (payload.steps.riskAssessment.status === "Aprovado" ||
          payload.steps.riskAssessment.status === "Condicionado" ||
          payload.steps.riskAssessment.status === "Reprovada" ||
          payload.steps.riskAssessment.status === "Com restrição" ||
          payload.steps.riskAssessment.status === "Com pendência(s)" ||
          payload.steps.riskAssessment.status ===
            "Com restrição e Com pendência(s)") &&
        !payload.noUpdateEmail
      ) {
        let oldRiskStatus;
        await db
          .collection("proposals")
          .doc(payload.id)
          .get()
          .then((proposal) => {
            oldRiskStatus = proposal.data().steps.riskAssessment.status;
          });
        if (oldRiskStatus !== payload.steps.riskAssessment.status) {
          if (
            (payload.email === "naodeclarado@cliente.com" &&
              payload.steps.riskAssessment.status === "Aprovado") ||
            payload.steps.riskAssessment.status != "Aprovado"
          ) {
            dispatch("riskAssessmentStatusHandler", {
              riskStatus: payload.steps.riskAssessment.status,
              email: payload.email,
              cpf: payload.cpf,
              name: payload.name,
              created_by: payload.created_by,
              riskAmount: payload.approvedFinancingAmount,
              phoneNumber: payload.phoneNumber,
              propertyType: payload.propertyType,
              propertyValue: payload.propertyValue,
              propertyCategory: payload.propertyCategory,
              intendedFinancingValue: payload.intendedFinancingValue,
              period: payload.period,
              amortizationSystem: payload.amortizationSystem,
              indexer: payload.indexer,
              fgts: payload.fgts,
            });
          } else if (payload.steps.riskAssessment.status === "Aprovado") {
            try {
              const sendMailForRiskStatus = firebase
                .functions()
                .httpsCallable("sendMailForRiskStatus");
              sendMailForRiskStatus({
                riskStatus: payload.steps.riskAssessment.status,
                email: payload.email,
                cpf: payload.cpf,
                name: payload.name,
                created_by: payload.created_by,
                riskAmount: payload.approvedFinancingAmount,
                phoneNumber: payload.phoneNumber,
                propertyType: payload.propertyType,
                propertyCategory: payload.propertyCategory,
                intendedFinancingValue: payload.intendedFinancingValue,
                period: payload.period,
                amortizationSystem: payload.amortizationSystem,
                indexer: payload.indexer,
                propertyValue: payload.propertyValue,
                fgts: payload.fgts ? "Sim" : "Não",
              })
                .then((res) => {
                  console.log("%c --res", "color: #0088CC", res);
                })
                .catch((e) => {
                  console.log("%c --e", "color: #00BF00", e);
                });
              commit("setError");
              commit("setErrorMessage", {
                color: "success",
                text: "Mail sent successfully",
              });
            } catch (error) {
              console.log("Error ao adicionar o doc: ", error);
              commit("setError");
              commit("setErrorMessage", {
                color: "danger",
                text: "Opsss...!",
              });
            }
          }
        }
      }*/
      /*if (
        payload.steps.contract.status === "Agendada" ||
        payload.steps.contract.status === "Contratada" ||
        payload.steps.contract.status === "Enviado" ||
        payload.steps.contract.status === "Conforme"
      ) {
        let oldContractStatus;
        await db
          .collection("proposals")
          .doc(payload.id)
          .get()
          .then((proposal) => {
            oldContractStatus = proposal.data().steps.contract.status;
          });
        if (oldContractStatus !== payload.steps.contract.status) {
          dispatch("contractStatusHandler", {
            status: payload.steps.contract.status,
            email: payload.email,
            cpf: payload.cpf,
            name: payload.name,
            created_by: payload.created_by,
            riskAmount: payload.approvedFinancingAmount,
          });
        }
      }*/

      /*if (
        payload.steps.engineering.status === "Válido" ||
        payload.steps.engineering.status === "Inválido" ||
        payload.steps.engineering.status === "Pept"
      ) {
        let oldEngineeringStatus;
        await db
          .collection("proposals")
          .doc(payload.id)
          .get()
          .then((proposal) => {
            oldEngineeringStatus = proposal.data().steps.engineering.status;
          });
        if (oldEngineeringStatus !== payload.steps.engineering.status) {
          dispatch("engineeringStatusHandler", {
            status: payload.steps.engineering.status,
            email: payload.email,
            cpf: payload.cpf,
            name: payload.name,
            created_by: payload.created_by,
            riskAmount: payload.approvedFinancingAmount,
          });
        }
      }*/

      let progressValue = 0;
      if (payload.steps.riskAssessment.actived)
        progressValue = progressValue + payload.steps.riskAssessment.progress;
      if (payload.steps.engineering.status == "Válido" && !payload.fgts)
        progressValue = progressValue + payload.steps.engineering.progress + 15;
      else if (payload.steps.engineering.actived)
        progressValue = progressValue + payload.steps.engineering.progress;
      if (payload.steps.forms.actived)
        progressValue = progressValue + payload.steps.forms.progress;
      if (payload.steps.dossier.actived)
        progressValue = progressValue + payload.steps.dossier.progress;
      if (payload.steps.contract.actived)
        progressValue = progressValue + payload.steps.contract.progress;
      if (payload.steps.fgts.actived)
        progressValue = progressValue + payload.steps.fgts.progress;
      //if (payload.steps.fgts.actived)  payload.steps.fgts.progress = progressValue + payload.steps.fgts.progress
      //if (!payload.fgts) {
      //  progressValue = progressValue + 15
      //}
      // dispatch('setProposalHistory', payload)

      const proposal = await db.collection("proposals").doc(payload.id);
      proposal
        .set(
          {
            bankBranch: payload.bankBranch,
            name: payload.name,
            cpf: payload.cpf,
            pis: payload.pis,
            occupation: payload.occupation,
            phoneNumber: payload.phoneNumber,
            maritalStatus: payload.maritalStatus,
            email: payload.email,
            salaryAmount: payload.salaryAmount,
            fgts: payload.fgts,
            progressValue: progressValue,
            propertyType: payload.propertyType,
            propertyCategory: payload.propertyCategory,
            propertyValue: payload.propertyValue,
            propertyLocation: payload.propertyLocation,
            propertyIQ: payload.propertyIQ ? payload.propertyIQ : false,
            verifiedSD: payload.verifiedSD ? payload.verifiedSD : false,
            intendedFinancingValue: payload.intendedFinancingValue,
            period: payload.period,
            amortizationSystem: payload.amortizationSystem,
            indexer: payload.indexer,
            approvedFinancingAmount: payload.approvedFinancingAmount,
            engineeringEvaluation: payload.engineeringEvaluation,
            operationModality: payload.operationModality,
            operationValue: payload.operationValue,
            participants: payload.participants,
            acquisitionForecast: payload.acquisitionForecast
              ? payload.acquisitionForecast
              : [],
            participantItems: payload.participantItems
              ? payload.participantItems
              : [],
            matricula: payload.matricula ? payload.matricula : 0,
            issueDate: payload.issueDate ? payload.issueDate : "",
            operationNumber: payload.operationNumber
              ? payload.operationNumber
              : 0,
            notaryExpensesAmount: payload.notaryExpensesAmount
              ? payload.notaryExpensesAmount
              : 0,
            fgtsValue: payload.fgtsValue ? payload.fgtsValue : 0,
            comite: payload.comite ? payload.comite : false,
            comiteChecked: payload.comiteChecked
              ? payload.comiteChecked
              : false,
            comiteIndeterminate: payload.comiteIndeterminate
              ? payload.comiteIndeterminate
              : false,
            steps: {
              note: payload.steps.note,
              riskAssessment: {
                actived: payload.steps.riskAssessment.actived,
                situation: payload.steps.riskAssessment.situation,
                status: payload.steps.riskAssessment.status,
                dueDate: payload.steps.riskAssessment.dueDate,
                badgeColor:
                  payload.notification || payload.alert
                    ? payload.steps.riskAssessment.badgeColor
                    : payload.steps.riskAssessment.color
                    ? payload.steps.riskAssessment.color
                    : "light",
                note: payload.steps.riskAssessment.note,
                progress: payload.steps.riskAssessment.progress
                  ? payload.steps.riskAssessment.progress
                  : 0,
              },
              engineering: {
                actived: payload.steps.engineering.actived,
                situation: payload.steps.engineering.situation,
                status: payload.steps.engineering.status,
                dueDate: payload.steps.engineering.dueDate,
                badgeColor: payload.alert
                  ? payload.steps.engineering.badgeColor
                  : payload.steps.engineering.color
                  ? payload.steps.engineering.color
                  : "light",
                note: payload.steps.engineering.note,
                progress: payload.steps.engineering.progress
                  ? payload.steps.engineering.progress
                  : 0,
                alertRule: payload.alert
                  ? payload.steps.engineering.alertRule
                  : true,
              },
              forms: {
                actived: payload.steps.forms.actived,
                situation: payload.steps.forms.situation,
                status: payload.steps.forms.status,
                dueDate: payload.steps.forms.dueDate,
                badgeColor: payload.alert
                  ? payload.steps.forms.badgeColor
                  : payload.steps.forms.color
                  ? payload.steps.forms.color
                  : "light",
                note: payload.steps.forms.note,
                progress: payload.steps.forms.progress
                  ? payload.steps.forms.progress
                  : 0,
                alertRule: payload.alert ? payload.steps.forms.alertRule : true,
              },
              fgts: {
                actived: payload.steps.fgts.actived,
                situation: payload.steps.fgts.situation,
                status: payload.steps.fgts.status,
                dueDate: payload.steps.fgts.dueDate,
                badgeColor: payload.alert
                  ? payload.steps.fgts.badgeColor
                  : payload.steps.fgts.color
                  ? payload.steps.fgts.color
                  : "light",
                note: payload.steps.fgts.note,
                progress: payload.steps.fgts.progress
                  ? payload.steps.fgts.progress
                  : 0,
                alertRule: payload.alert ? payload.steps.fgts.alertRule : true,
              },
              dossier: {
                actived: payload.steps.dossier.actived,
                situation: payload.steps.dossier.situation,
                status: payload.steps.dossier.status,
                dueDate: payload.steps.dossier.dueDate,
                badgeColor: payload.alert
                  ? payload.steps.dossier.badgeColor
                  : payload.steps.dossier.color
                  ? payload.steps.dossier.color
                  : "light",
                note: payload.steps.dossier.note,
                progress: payload.steps.dossier.progress
                  ? payload.steps.dossier.progress
                  : 0,
              },
              contract: {
                actived: payload.steps.contract.actived,
                situation: payload.steps.contract.situation,
                status: payload.steps.contract.status,
                dueDate: payload.steps.contract.dueDate,
                badgeColor: payload.alert
                  ? payload.steps.contract.badgeColor
                  : payload.steps.contract.color
                  ? payload.steps.contract.color
                  : "light",
                note: payload.steps.contract.note,
                progress: payload.steps.contract.progress
                  ? payload.steps.contract.progress
                  : 0,
                alertRule: payload.alert
                  ? payload.steps.contract.alertRule
                  : true,
              },
            },

            comments: payload.comments,

            updated: new Date(),
            actived: payload.actived,
            expected: payload.expected,
            pendingList: payload.pendingList ? payload.pendingList : [],
            pendingFgtsList: payload.pendingFgtsList
              ? payload.pendingFgtsList
              : [],
            bidderList: payload.bidderList ? payload.bidderList : [],
          },
          { merge: true }
        )
        .then(async () => {
          // console.log("Proposta Atualizada com sucesso!");
          commit("updateProposal", payload);
          state.notificationsToAdd.forEach(async (not) => {
            await dispatch("addNotification", not);
          });

          await commit("removeModificationNotification", []);
          if (!payload.alert) {
            dispatch("setProposalHistory", payload);
          }
          //commit('setProposal', {name: payload, id: doc.id})
          commit("setError");
          commit("setErrorMessage", {
            color: "success",
            text: "Proposta atualizada com sucesso!",
          });
        })
        .catch((e) => {
          console.log(e);
          commit("setError");
          commit("setErrorMessage", {
            color: "danger",
            text: "Opsss... Algo aconteceu!",
          });
        });
      if (payload.alert) {
        proposal
          .set(
            {
              steps: {
                engineering: {
                  updatedAlert: payload.steps.engineering.updatedAlert
                    ? payload.steps.engineering.updatedAlert
                    : "",
                  // alertRule: payload.notification ? payload.steps.engineering.alertRule : true,
                  alertType: payload.steps.engineering.alertType
                    ? payload.steps.engineering.alertType
                    : "",
                },
                forms: {
                  updatedAlert: payload.steps.forms.updatedAlert
                    ? payload.steps.forms.updatedAlert
                    : "",
                  // alertRule: payload.notification ? payload.steps.forms.alertRule : true,
                  alertType: payload.steps.forms.alertType
                    ? payload.steps.forms.alertType
                    : "",
                },
                fgts: {
                  updatedAlert: payload.steps.fgts.updatedAlert
                    ? payload.steps.fgts.updatedAlert
                    : "",
                  // alertRule: payload.notification ? payload.steps.fgts.alertRule : true,
                  alertType: payload.steps.fgts.alertType
                    ? payload.steps.fgts.alertType
                    : "",
                },
                contract: {
                  updatedAlert: payload.steps.contract.updatedAlert
                    ? payload.steps.contract.updatedAlert
                    : "",
                  // alertRule: payload.notification ? payload.steps.contract.alertRule : true,
                  alertType: payload.steps.contract.alertType
                    ? payload.steps.contract.alertType
                    : "",
                },
              },
            },
            { merge: true }
          )
          .then(() => {
            commit("updateProposal", payload);
            commit("setError");
            commit("setErrorMessage", {
              color: "success",
              text: "Proposta atualizada com sucesso!",
            });
          })
          .catch((e) => {
            console.log(e);
            commit("setError");
            commit("setErrorMessage", {
              color: "danger",
              text: "Opsss... Algo aconteceu!",
            });
          });
      }
    },

    async updateProposalShare({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .set({ shareWith: payload.users }, { merge: true });
        return {
          success: true,
          msg: "Shared",
        };
      } catch (e) {
        console.log(e);
      }
    },

    async setProposalHistory({ state }, payload) {
      let proposal = state.proposalToEdit;
      let obj = {};
      for (let key in payload) {
        if (
          key !== "steps" &&
          key !== "id" &&
          key !== "created" &&
          key !== "created_by" &&
          key !== "updated" &&
          payload[key] &&
          payload[key] !== proposal[key]
        ) {
          obj[key] = payload[key];
        }
      }
      for (let stepkey in payload["steps"]) {
        if (stepkey !== "note") {
          let stepkeyObj = JSON.parse(
            JSON.stringify(payload["steps"][stepkey])
          );
          if (proposal["steps"][stepkey].color === undefined) {
            console.log(
              stepkey,
              "working0004",
              payload["steps"][stepkey].color
            );
            delete payload["steps"][stepkey].color;
          }
          if (
            stepkey !== "color" &&
            JSON.stringify(payload["steps"][stepkey]) !==
              JSON.stringify(proposal["steps"][stepkey])
          ) {
            if (obj.steps) {
              obj.steps[`${stepkey}`] = payload["steps"][stepkey];
            } else {
              obj["steps"] = {
                [`${stepkey}`]: payload["steps"][stepkey],
              };
            }
            obj["steps"][`${stepkey}`].badgeColor = stepkeyObj.color;
          }
        } else {
          if (payload["steps"][stepkey] !== proposal["steps"][stepkey]) {
            obj["steps"] = {
              [`${stepkey}`]: payload["steps"][stepkey],
            };
          }
        }
      }
      if (obj && Object.keys(obj).length) {
        try {
          await db.collection("userHistory").add({
            updatedProposalValue: obj,
            proposalId: payload.id,
            user: state.user.name,
            date:
              new Date().getFullYear() +
              "-" +
              (new Date().getMonth() + 1) +
              "-" +
              new Date().getDate(),
            time:
              new Date().getHours() +
              ":" +
              new Date().getMinutes() +
              ":" +
              new Date().getSeconds(),
          });
        } catch (error) {
          console.log(error);
        }
      }
      router.push("/");
    },

    deleteProposal({ commit }, id) {
      db.collection("proposals")
        .doc(id)
        .delete()
        .then(() => {
          console.log("Proposal deleted");
          //dispatch('getProposals')
          commit("delProposal", id);
          commit("setError");
          commit("setErrorMessage", {
            color: "success",
            text: "Proposta excluída com sucesso!",
          });
        });
    },

    async getTimeLine({ commit }, payload) {
      let responseArr = [];
      await db
        .collection("userHistory")
        .where("proposalId", "==", payload.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            responseArr.push(doc.data());
          });
        });
      return responseArr;
    },

    getFgtsDemand({ commit }) {
      commit("setDataPreloader", true);

      const fgtsDemands = [];

      db.collection("fgtsDemand")
        .orderBy("created", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //console.log(doc.id);
            console.log(doc.data());
            let fgtsDemand = doc.data();
            fgtsDemand.id = doc.id;
            fgtsDemands.push(fgtsDemand);
          });
          commit("setDataPreloader", false);
        });
      commit("setFgtsDemands", fgtsDemands);
    },

    async setProposalOpen({ commit }, payload) {
      const proposal = await db.collection("proposals").doc(payload.id);
      proposal
        .set({ isOpen: payload.val }, { merge: true })
        .then(async () => {})
        .catch((e) => {});
    },

    /* ==================================================================
    Blog Function
    ================================================================== */

    async createPost({ commit, dispatch }, payload) {
      const user = firebase.auth().currentUser;

      try {
        const doc = await db.collection("blog").add({
          author: payload.author,
          body: payload.body,
          //categories: [],
          created: new Date(),
          image_alt: payload.image_alt,
          updated: "",
          meta_description: payload.meta_description,
          published: payload.published,
          seo_title: payload.seo_title,
          slug: payload.slug,
          status: payload.status,
          subTitle: payload.subTitle,
          summary: payload.summary,
          tags: payload.tags,
          title: payload.title,
        });
        commit("setPost", { name: payload, id: doc.id });
        router.push({ name: "Articles" });
      } catch (error) {
        console.log(error);
      }
      commit("setErrorMessage", {
        color: "success",
        text: "Post criado com sucesso!",
      });
    },

    getPosts({ commit }) {
      commit("setDataPreloader", true);

      db.collection("blog")
        .get()
        .then((query) => {
          const posts = [];
          query.forEach((element) => {
            //this.articles = element.data();
            let post = element.data();
            post.id = element.id;
            posts.push(post);
          });
          commit("setPosts", posts);
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },

    getPostForEdit({ commit }, id) {
      db.collection("blog")
        .doc(id)
        .get()
        .then((doc) => {
          console.log(doc.data());
          let post = doc.data();
          post.id = doc.id;
          commit("setPostToEdit", post);
        });
    },

    async editPost({ commit }, payload) {
      console.log(payload, "23123213");
      if (payload.file) {
        let storage = firebase.storage().ref();
        const ref = await storage.child(`post/${payload.id}/image.png`);
        await ref.put(payload.file);
        const downloadUrl = await ref.getDownloadURL();
        payload.image_url = downloadUrl;
      }
      db.collection("blog")
        .doc(payload.id)
        .update({
          author: payload.author,
          body: payload.body,
          //categories: [],
          //created: new Date(),
          image_alt: payload.image_alt,
          image_url: payload.image_url ? payload.image_url : "",
          updated: new Date(),
          meta_description: payload.meta_description,
          published: payload.published,
          seo_title: payload.seo_title,
          slug: payload.slug,
          status: payload.status,
          subTitle: payload.subTitle,
          summary: payload.summary,
          tags: payload.tags,
          title: payload.title,
          post_date: payload.post_date ? payload.post_date : "",
        })
        .then(() => {
          //console.log("Proposta Atualizada com sucesso!");
          router.push({ name: "Articles" });

          commit("setError");
          commit("setErrorMessage", {
            color: "success",
            text: "Post atualizada com sucesso!",
          });
        })
        .catch((e) => {
          console.log(e);
          commit("setError");
          commit("setErrorMessage", {
            color: "danger",
            text: "Opsss... Algo aconteceu!",
          });
        });
    },

    deletePost({ commit }, id) {
      db.collection("blog")
        .doc(id)
        .delete()
        .then(() => {
          console.log("Post deleted");
          //dispatch('getProposals')
          commit("delPost", id);
          commit("setError");
          commit("setErrorMessage", {
            color: "success",
            text: "Post excluído com sucesso!",
          });
        });
    },

    /* ==================================================================
    Error Function
    ================================================================== */

    dismissed({ commit }) {
      commit("setDismissCountDown", 0);
    },

    async getDocuments({ state, commit }, payload) {
      let pdfArray = [];
      let pngArray = [];
      commit("getDocuments", { pdfArray: pdfArray, pngArray: pngArray });
      try {
        let storage = firebase.storage().ref();
        var listRef = await storage.child(`${payload}`);
        await listRef.listAll().then(function(res) {
          res.items.forEach(function(itemRef) {
            var itemPath = itemRef.location.path;
            var fileRef = storage.child(`${itemPath}`);
            fileRef
              .getDownloadURL()
              .then(function(url) {
                var fileObj = {
                  url: url,
                  name: itemRef.name,
                };
                if (
                  itemRef.name.substring(itemRef.name.lastIndexOf(".")) ==
                  ".pdf"
                ) {
                  pdfArray.push(fileObj);
                }
                if (
                  itemRef.name.substring(itemRef.name.lastIndexOf(".")) ==
                  ".jpg"
                ) {
                  pngArray.push(fileObj);
                }
                commit("getDocuments", {
                  pdfArray: pdfArray,
                  pngArray: pngArray,
                });
              })
              .catch(function(error) {});
          });
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while getting documents!",
        });
      }
    },

    // common tasks
    async addCommonBuyer({ commit }, payload) {
      try {
        const addedBuyer = await db.collection("buyer").add(payload);

        await db
          .collection("buyer")
          .doc(addedBuyer.id)
          .set(
            { id: addedBuyer.id },
            {
              merge: true,
            }
          );
        commit("setErrorMessage", {
          color: "success",
          text: `${payload.name} added to buyer task!`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding buyer task!",
        });
      }
    },
    async addCommonSeller({ commit }, payload) {
      try {
        const addedSeller = await db.collection("seller").add(payload);

        await db
          .collection("seller")
          .doc(addedSeller.id)
          .set(
            { id: addedSeller.id },
            {
              merge: true,
            }
          );
        commit("setErrorMessage", {
          color: "success",
          text: `${payload.name} added to seller task!`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding seller task!",
        });
      }
    },
    async addCommonProperty({ commit }, payload) {
      try {
        const addedProperty = await db.collection("property").add(payload);

        await db
          .collection("property")
          .doc(addedProperty.id)
          .set(
            { id: addedProperty.id },
            {
              merge: true,
            }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.name} added to property task!`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding property task!",
        });
      }
    },

    async updateCommonBuyer({ commit }, payload) {
      try {
        await db
          .collection("buyer")
          .doc(payload.tid)
          .set(
            {
              name: payload.name,
              required: payload.required,
            },
            {
              merge: true,
            }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.name} updated`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating buyer task!",
        });
      }
    },
    async updateCommonSeller({ commit }, payload) {
      try {
        await db
          .collection("seller")
          .doc(payload.tid)
          .set(
            {
              name: payload.name,
              required: payload.required,
            },
            {
              merge: true,
            }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.name} updated`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating buyer task!",
        });
      }
    },
    async updateCommonProperty({ commit }, payload) {
      try {
        await db
          .collection("property")
          .doc(payload.tid)
          .set(
            {
              name: payload.name,
              required: payload.required,
            },
            {
              merge: true,
            }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.name} updated`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating buyer task!",
        });
      }
    },

    async updateCommonBuyerSubtask({ commit }, payload) {
      try {
        await db
          .collection("buyer")
          .doc(payload.tid)
          .collection("subtasks")
          .doc(payload.sid)
          .set(
            {
              name: payload.name,
              backName: payload.backName,
            },
            {
              merge: true,
            }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.name} updated`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating buyer task!",
        });
      }
    },
    async updateCommonSellerSubtask({ commit }, payload) {
      try {
        await db
          .collection("seller")
          .doc(payload.tid)
          .collection("subtasks")
          .doc(payload.sid)
          .set(
            {
              name: payload.name,
              backName: payload.backName,
            },
            {
              merge: true,
            }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.name} updated`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating buyer task!",
        });
      }
    },
    async updateCommonPropertySubtask({ commit }, payload) {
      try {
        await db
          .collection("property")
          .doc(payload.tid)
          .collection("subtasks")
          .doc(payload.sid)
          .set(
            {
              name: payload.name,
              backName: payload.backName,
            },
            {
              merge: true,
            }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.name} updated`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating buyer task!",
        });
      }
    },

    async deleteCommonBuyer({ commit }, id) {
      try {
        await db
          .collection("buyer")
          .doc(id)
          .delete();

        commit("setErrorMessage", {
          color: "success",
          text: `task deleted`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding buyer task!",
        });
      }
    },
    async deleteCommonSeller({ commit }, id) {
      try {
        await db
          .collection("seller")
          .doc(id)
          .delete();

        commit("setErrorMessage", {
          color: "success",
          text: `task deleted`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while deleting seller task!",
        });
      }
    },
    async deleteCommonProperty({ commit }, id) {
      try {
        await db
          .collection("property")
          .doc(id)
          .delete();

        commit("setErrorMessage", {
          color: "success",
          text: `task deleted`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while deleting property task!",
        });
      }
    },

    async deleteCommonBuyerSubtask({ commit }, payload) {
      try {
        await db
          .collection("buyer")
          .doc(payload.tid)
          .collection("subtasks")
          .doc(payload.sid)
          .delete();

        commit("setErrorMessage", {
          color: "success",
          text: `subtask deleted`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding buyer task!",
        });
      }
    },
    async deleteCommonSellerSubtask({ commit }, payload) {
      try {
        await db
          .collection("seller")
          .doc(payload.tid)
          .collection("subtasks")
          .doc(payload.sid)
          .delete();

        commit("setErrorMessage", {
          color: "success",
          text: `subtask deleted`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding seller task!",
        });
      }
    },
    async deleteCommonPropertySubtask({ commit }, payload) {
      try {
        await db
          .collection("property")
          .doc(payload.tid)
          .collection("subtasks")
          .doc(payload.sid)
          .delete();

        commit("setErrorMessage", {
          color: "success",
          text: `subtask deleted`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding property task!",
        });
      }
    },

    async addCommonBuyerSubtask({ commit }, payload) {
      try {
        const addedSubtask = await db
          .collection("buyer")
          .doc(payload.id)
          .collection("subtasks")
          .add(payload.subtask);

        await db
          .collection("buyer")
          .doc(payload.id)
          .collection("subtasks")
          .doc(addedSubtask.id)
          .set(
            {
              id: addedSubtask.id,
            },
            { merge: true }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.subtask.name} added to subtask`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding property task!",
        });
      }
    },
    async addCommonSellerSubtask({ commit }, payload) {
      try {
        const addedSubtask = await db
          .collection("seller")
          .doc(payload.id)
          .collection("subtasks")
          .add(payload.subtask);

        await db
          .collection("seller")
          .doc(payload.id)
          .collection("subtasks")
          .doc(addedSubtask.id)
          .set(
            {
              id: addedSubtask.id,
            },
            { merge: true }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.subtask.name} added to subtask`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding seller task!",
        });
      }
    },
    async addCommonPropertySubtask({ commit }, payload) {
      try {
        const addedSubtask = await db
          .collection("property")
          .doc(payload.id)
          .collection("subtasks")
          .add(payload.subtask);

        await db
          .collection("property")
          .doc(payload.id)
          .collection("subtasks")
          .doc(addedSubtask.id)
          .set(
            {
              id: addedSubtask.id,
            },
            { merge: true }
          );

        commit("setErrorMessage", {
          color: "success",
          text: `${payload.subtask.name} added to subtask`,
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while adding property task!",
        });
      }
    },

    // async addCommonBuyerTask({ state, commit }, payload) {
    //   try {
    //     var buyer = await db
    //       .collection("tasks")
    //       .doc("buyer")
    //       .set({ array: payload });
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while adding buyer task!",
    //     });
    //   }
    // },
    // async addCommonSellerTask({ state, commit }, payload) {
    //   try {
    //     var buyer = await db
    //       .collection("tasks")
    //       .doc("seller")
    //       .set({ array: payload });
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while adding seller task!",
    //     });
    //   }
    // },
    // async addCommonPropertyTask({ state, commit }, payload) {
    //   try {
    //     var buyer = await db
    //       .collection("tasks")
    //       .doc("property")
    //       .set({ array: payload });
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while adding property task!",
    //     });
    //   }
    // },

    // async getCommonBuyerTask({ state, commit }) {
    //   try {
    //     var buyer = await db
    //       .collection("tasks")
    //       .doc("buyer")
    //       .get();
    //     state.getCommonBuyerTaskList = buyer.data().array;
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while getting buyer task!",
    //     });
    //   }
    // },

    async fetchCommonBuyer({ state, commit }) {
      try {
        await db
          .collection("buyer")
          .get()
          .then(async (tasks) => {
            state.commonBuyerTask = [];
            for (let index = 0; index < tasks.docs.length; index++) {
              state.commonBuyerTask.push(tasks.docs[index].data());
              await db
                .collection("buyer")
                .doc(tasks.docs[index].data().id)
                .collection("subtasks")
                .get()
                .then((subtasks) => {
                  if (state.commonBuyerTask[index]) {
                    state.commonBuyerTask[index].subtask = [];
                    subtasks.docs.forEach((subtask) => {
                      state.commonBuyerTask[index].subtask.push(subtask.data());
                    });
                  }
                });
            }
          });
      } catch (error) {
        console.log(error, "errorerrorerrorerrorerror");
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while getting common buyer task!",
        });
      }
    },
    async fetchCommonSeller({ state, commit }) {
      try {
        state.commonSellerTask = [];
        await db
          .collection("seller")
          .get()
          .then(async (tasks) => {
            for (let index = 0; index < tasks.docs.length; index++) {
              state.commonSellerTask.push(tasks.docs[index].data());
              await db
                .collection("seller")
                .doc(tasks.docs[index].data().id)
                .collection("subtasks")
                .get()
                .then((subtasks) => {
                  state.commonSellerTask[index].subtask = [];
                  subtasks.docs.forEach((subtask) => {
                    state.commonSellerTask[index].subtask.push(subtask.data());
                  });
                });
            }
          });
      } catch (error) {
        console.log(error, "errorerror");
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while getting common seller task!",
        });
      }
    },
    async fetchCommonProperty({ state, commit }) {
      try {
        state.commonPropertyTask = [];
        await db
          .collection("property")
          .get()
          .then(async (tasks) => {
            for (let index = 0; index < tasks.docs.length; index++) {
              state.commonPropertyTask.push(tasks.docs[index].data());
              await db
                .collection("property")
                .doc(tasks.docs[index].data().id)
                .collection("subtasks")
                .get()
                .then((subtasks) => {
                  state.commonPropertyTask[index].subtask = [];
                  subtasks.docs.forEach((subtask) => {
                    state.commonPropertyTask[index].subtask.push(
                      subtask.data()
                    );
                  });
                });
            }
          });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while getting common property task!",
        });
      }
    },

    async fetchProposalBuyer({ state, commit }, id) {
      try {
        await commit("clearProposalBuyer");
        await db
          .collection("proposals")
          .doc(id)
          .collection("buyer")
          .get()
          .then(async (tasks) => {
            for (let index = 0; index < tasks.docs.length; index++) {
              state.proposalBuyerTask.push(tasks.docs[index].data());
              await db
                .collection("proposals")
                .doc(id)
                .collection("buyer")
                .doc(tasks.docs[index].data().id)
                .collection("subtasks")
                .get()
                .then((subtasks) => {
                  state.proposalBuyerTask[index].subtask = [];
                  subtasks.docs.forEach((subtask) => {
                    state.proposalBuyerTask[index].subtask.push(subtask.data());
                  });
                });
            }
          });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while getting buyer task!",
        });
      }
    },
    async fetchProposalSeller({ state, commit }, id) {
      try {
        await commit("clearProposalSeller");
        await db
          .collection("proposals")
          .doc(id)
          .collection("seller")
          .get()
          .then(async (tasks) => {
            for (let index = 0; index < tasks.docs.length; index++) {
              state.proposalSellerTask.push(tasks.docs[index].data());
              await db
                .collection("proposals")
                .doc(id)
                .collection("seller")
                .doc(tasks.docs[index].data().id)
                .collection("subtasks")
                .get()
                .then((subtasks) => {
                  state.proposalSellerTask[index].subtask = [];
                  subtasks.docs.forEach((subtask) => {
                    state.proposalSellerTask[index].subtask.push(
                      subtask.data()
                    );
                  });
                });
            }
          });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while getting seller task!",
        });
      }
    },
    async fetchProposalProperty({ state, commit }, id) {
      try {
        await commit("clearProposalProperty");
        await db
          .collection("proposals")
          .doc(id)
          .collection("property")
          .get()
          .then(async (tasks) => {
            for (let index = 0; index < tasks.docs.length; index++) {
              state.proposalPropertyTask.push(tasks.docs[index].data());
              await db
                .collection("proposals")
                .doc(id)
                .collection("property")
                .doc(tasks.docs[index].data().id)
                .collection("subtasks")
                .get()
                .then((subtasks) => {
                  state.proposalPropertyTask[index].subtask = [];
                  subtasks.docs.forEach((subtask) => {
                    state.proposalPropertyTask[index].subtask.push(
                      subtask.data()
                    );
                  });
                });
            }
          });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while getting seller task!",
        });
      }
    },

    // async addSelectedBuyerTask({ commit }, payload) {
    //   try {
    //     await db
    //       .collection("proposals")
    //       .doc(payload.id)
    //       .collection("buyer")
    //       .doc(payload.task.id)
    //       .set(payload.task)
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while getting buyer task!",
    //     });
    //   }
    // },

    // Update proposal buyer
    async updateSelectedBuyerTask({ commit, dispatch }, payload) {
      console.log(payload, "11111111");
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("buyer")
          .doc(payload.task.id)
          .set(
            {
              name: payload.task.name,
              value: payload.task.value,
              id: payload.task.id,
            },
            { merge: true }
          );
        await dispatch("checkBuyerUpdateRequired", payload);
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating buyer task!",
        });
      }
    },
    async checkBuyerUpdateRequired({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("buyer")
          .doc(payload.task.id)
          .get()
          .then(async (task) => {
            if (!task.data().updateRequired) {
              await db
                .collection("proposals")
                .doc(payload.id)
                .collection("buyer")
                .doc(payload.task.id)
                .set(
                  {
                    updateRequired: "never",
                  },
                  { merge: true }
                );
            }
          });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while check buyer task!",
        });
      }
    },
    async updateSelectedBuyerRequired({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("buyer")
          .doc(payload.task.id)
          .set(
            {
              name: payload.task.name,
              required: payload.task.required,
              updateRequired: firebase.firestore.FieldValue.serverTimestamp(),
              id: payload.task.id,
              value: payload.task.value,
            },
            { merge: true }
          );
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating buyer task!",
        });
      }
    },

    // Update proposal seller
    async updateSelectedSellerTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("seller")
          .doc(payload.task.id)
          .set(
            {
              name: payload.task.name,
              required: payload.task.required,
              value: payload.task.value,
              id: payload.task.id,
            },
            { merge: true }
          );
        await dispatch("checkSellerUpdateRequired", payload);
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating seller task!",
        });
      }
    },
    async checkSellerUpdateRequired({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("seller")
          .doc(payload.task.id)
          .get()
          .then(async (task) => {
            if (!task.data().updateRequired) {
              await db
                .collection("proposals")
                .doc(payload.id)
                .collection("seller")
                .doc(payload.task.id)
                .set(
                  {
                    updateRequired: "never",
                  },
                  { merge: true }
                );
            }
          });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while check seller task!",
        });
      }
    },
    async updateSelectedSellerRequired({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("seller")
          .doc(payload.task.id)
          .set(
            {
              name: payload.task.name,
              required: payload.task.required,
              updateRequired: firebase.firestore.FieldValue.serverTimestamp(),
              id: payload.task.id,
              value: payload.task.value,
            },
            { merge: true }
          );
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating seller task!",
        });
      }
    },

    // Update proposal property
    async updateSelectedPropertyTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("property")
          .doc(payload.task.id)
          .set(
            {
              name: payload.task.name,
              required: payload.task.required,
              value: payload.task.value,
              id: payload.task.id,
            },
            { merge: true }
          );
        await dispatch("checkPropertyUpdateRequired", payload);
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating property task!",
        });
      }
    },
    async checkPropertyUpdateRequired({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("property")
          .doc(payload.task.id)
          .get()
          .then(async (task) => {
            if (!task.data().updateRequired) {
              await db
                .collection("proposals")
                .doc(payload.id)
                .collection("property")
                .doc(payload.task.id)
                .set(
                  {
                    updateRequired: "never",
                  },
                  { merge: true }
                );
            }
          });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while check property task!",
        });
      }
    },
    async updateSelectedPropertyRequired({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("property")
          .doc(payload.task.id)
          .set(
            {
              name: payload.task.name,
              required: payload.task.required,
              updateRequired: firebase.firestore.FieldValue.serverTimestamp(),
              id: payload.task.id,
              value: payload.task.value,
            },
            { merge: true }
          );
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating property task!",
        });
      }
    },

    async updateSelectedBuyerSubTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("buyer")
          .doc(payload.task.id)
          .collection("subtasks")
          .doc(payload.subtask.id)
          .set(payload.subtask);
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating buyer subtask!",
        });
      }
    },
    async updateSelectedSellerSubTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("seller")
          .doc(payload.task.id)
          .collection("subtasks")
          .doc(payload.subtask.id)
          .set(payload.subtask);
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while getting seller task!",
        });
      }
    },
    async updateSelectedPropertySubTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("property")
          .doc(payload.task.id)
          .collection("subtasks")
          .doc(payload.subtask.id)
          .set(payload.subtask);
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while updating seller subtask!",
        });
      }
    },

    async deleteSelectedBuyerTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("buyer")
          .doc(payload.task.id)
          .collection("subtasks")
          .get()
          .then(async (subtasks) => {
            for (const subtask of subtasks.docs) {
              console.log();
              await db
                .collection("proposals")
                .doc(payload.id)
                .collection("buyer")
                .doc(payload.task.id)
                .collection("subtasks")
                .doc(subtask.data().id)
                .delete();
            }
          });

        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("buyer")
          .doc(payload.task.id)
          .delete();
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while delete buyer task!",
        });
      }
    },
    async deleteSelectedSellerTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("seller")
          .doc(payload.task.id)
          .collection("subtasks")
          .get()
          .then(async (subtasks) => {
            for (const subtask of subtasks.docs) {
              await db
                .collection("proposals")
                .doc(payload.id)
                .collection("seller")
                .doc(payload.task.id)
                .collection("subtasks")
                .doc(subtask.data().id)
                .delete();
            }
          });

        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("seller")
          .doc(payload.task.id)
          .delete();
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while delete buyer task!",
        });
      }
    },
    async deleteSelectedPropertyTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("property")
          .doc(payload.task.id)
          .collection("subtasks")
          .get()
          .then(async (subtasks) => {
            for (const subtask of subtasks.docs) {
              await db
                .collection("proposals")
                .doc(payload.id)
                .collection("property")
                .doc(payload.task.id)
                .collection("subtasks")
                .doc(subtask.data().id)
                .delete();
            }
          });

        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("property")
          .doc(payload.task.id)
          .delete();
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while delete buyer task!",
        });
      }
    },

    async deleteSelectedBuyerSubTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("buyer")
          .doc(payload.task.id)
          .collection("subtasks")
          .doc(payload.subtask.id)
          .delete();
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while delete buyer task!",
        });
      }
    },
    async deleteSelectedSellerSubTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("seller")
          .doc(payload.task.id)
          .collection("subtasks")
          .doc(payload.subtask.id)
          .delete();
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while delete buyer task!",
        });
      }
    },
    async deleteSelectedPropertySubTask({ commit }, payload) {
      try {
        await db
          .collection("proposals")
          .doc(payload.id)
          .collection("property")
          .doc(payload.task.id)
          .collection("subtasks")
          .doc(payload.subtask.id)
          .delete();
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error while delete buyer task!",
        });
      }
    },

    async updatePeriodAmount({ commit }, payload) {
      try {
        console.log(payload, "payloadpayload");
        await db
          .collection("goal")
          .doc("period")
          .set({
            amount: payload,
          });
        commit("setErrorMessage", {
          color: "success",
          text: "Updated!",
        });
      } catch (error) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error",
        });
      }
    },

    async fetchPeriodAmount({ commit }, payload) {
      try {
        console.log(payload, "payloadpayload");
        await db
          .collection("goal")
          .doc("period")
          .get()
          .then((doc) => {
            commit("setPeriodAmount", doc.data().amount);
          });
      } catch (error) {
        console.log(error, "errorerror");
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error",
        });
      }
    },

    async getCurrentYearProposals({ commit }) {
      try {
        const start = moment().startOf("year");
        const end = moment().endOf("year");
        let proposals = [];
        await db
          .collection("proposals")
          .where("steps.contract.status", "in", ["Contratada", "Evoluída"])
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let proposal = doc.data();
              proposal.id = doc.id;
              const approvedDate =
                moment(proposal.steps.contract.dueDate).format("X") * 1000;
              if (start <= approvedDate && approvedDate <= end) {
                proposals.push(proposal);
              }
            });
            commit("setCurrentYearProposals", proposals);
          });
      } catch (e) {
        commit("setErrorMessage", {
          color: "danger",
          text: "Getting some error to fetch proposals",
        });
      }
    },

    async addNotification({}, data) {
      try {
        await db
          .collection("notifications")
          .doc()
          .set(data);
      } catch (error) {
        console.log(error);
      }
    },

    async getNotifications({ commit, state }) {
      commit("mutateNotification", []);
      let notifications = [];
      await db
        .collection("notifications")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            let notification = doc.data();
            notification["notId"] = doc.id;
            notifications.push(notification);
          });
        });

      commit("mutateNotification", notifications);
    },
    async removeNotification({ commit }, payload) {
      await db
        .collection("notifications")
        .doc(payload.notId)
        .get()
        .then(async (noti) => {
          if (noti.exists) {
            await db
              .collection("notifications")
              .doc(payload.notId)
              .delete();
          } else {
            commit("setErrorMessage", {
              color: "danger",
              text: "Notification is already deleted",
            });
          }
        });
    },

    // async getCommonSellerTask({ state, commit }, payload) {
    //   try {
    //     var seller = await db
    //       .collection("tasks")
    //       .doc("seller")
    //       .get();
    //     state.getCommonSellerTaskList = seller.data().array;
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while getting seller task!",
    //     });
    //   }
    // },
    // async getCommonPropertyTask({ state, commit }, payload) {
    //   try {
    //     var property = await db
    //       .collection("tasks")
    //       .doc("property")
    //       .get();
    //     state.getCommonPropertyTaskList = property.data().array;
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while getting documents!",
    //     });
    //   }
    // },

    // async addBuyerTask({ state, commit }, payload) {
    //   try {
    //     var buyer = await db
    //       .collection("proposals")
    //       .doc(`${payload.id}`)
    //       .collection("tasks")
    //       .doc("buyer")
    //       .set({ array: payload.array });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // async addSellerTask({ state, commit }, payload) {
    //   try {
    //     await db
    //       .collection("proposals")
    //       .doc(`${payload.id}`)
    //       .collection("tasks")
    //       .doc("seller")
    //       .set({ array: payload.array });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // async addPropertyTask({ state, commit }, payload) {
    //   try {
    //     await db
    //       .collection("proposals")
    //       .doc(`${payload.id}`)
    //       .collection("tasks")
    //       .doc("property")
    //       .set({ array: payload.array });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    // async getBuyerTask({ state, commit }, payload) {
    //   try {
    //     var buyer = await db
    //       .collection("proposals")
    //       .doc(payload)
    //       .collection("tasks")
    //       .doc("buyer")
    //       .get();
    //     if (!buyer.data()) {
    //       state.getBuyerTaskList = [];
    //     } else {
    //       state.getBuyerTaskList = buyer.data().array;
    //     }
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while getting documents!",
    //     });
    //   }
    // },
    // async getSellerTask({ state, commit }, payload) {
    //   try {
    //     var seller = await db
    //       .collection("proposals")
    //       .doc(payload)
    //       .collection("tasks")
    //       .doc("seller")
    //       .get();
    //     if (!seller.data()) {
    //       state.getSellerTaskList = [];
    //     } else {
    //       state.getSellerTaskList = seller.data().array;
    //     }
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while getting seller task!",
    //     });
    //   }
    // },
    // async getPropertyTask({ state, commit }, payload) {
    //   try {
    //     var property = await db
    //       .collection("proposals")
    //       .doc(payload)
    //       .collection("tasks")
    //       .doc("property")
    //       .get();
    //     if (!property.data()) {
    //       state.getPropertyTaskList = [];
    //     } else {
    //       state.getPropertyTaskList = property.data().array;
    //     }
    //   } catch (error) {
    //     commit("setErrorMessage", {
    //       color: "danger",
    //       text: "Getting some error while getting seller task!",
    //     });
    //   }
    // },
    // async getPropertyFromAnywhere ({ state, commit}, payload) {
    //   try {
    //     var seller = await db.collection('proposals')
    //     .doc(payload)
    //     .collection('Property')
    //     .get().then(function(collection) {
    //       collection.forEach(function(doc) {
    //         // doc.data() is never undefined for query doc snapshots
    //         console.log(doc.id, " => ", doc.data());
    //         state.abc.push(doc.data())
    //       });
    //     })
    //       } catch (error) {
    //       commit('setErrorMessage', {
    //         color: 'danger',
    //         text: 'Getting some error while getting seller task!'
    //       });
    //     }
    // },
    // async addquestion ({ state, commit}, payload) {
    //   try {
    //     var seller = await db.collection('tasks')
    //     .doc('property')
    //     .update('array',payload)
    //     console.log(state.abc,"LLLLLLLLLLLL")
    //       } catch (error) {
    //       commit('setErrorMessage', {
    //         color: 'danger',
    //         text: 'Getting some error while getting seller task!'
    //       });
    //     }
    // }
  },
  getters: {
    existingUser(state) {
      if (
        state.user === null ||
        state.user === "" ||
        state.user === undefined
      ) {
        return false;
      } else {
        return true;
      }
    },
    // Filtra lista de proposta de acordo com o dado inserido no input Search
    filteredList(state) {
      return state.proposals;
      // .filter(proposal => {
      //   return (
      //     proposal.cpf.toLowerCase().includes(state.searchData.toLowerCase())
      //     || proposal.bankBranch.toLowerCase().includes(state.searchData.toLowerCase())
      //     || proposal.name.toLowerCase().includes(state.searchData.toLowerCase())
      //   );
      // });
    },
  },
  modules: {
    Notification,
  },
});
